webpackJsonp(["site__fus078"],{

/***/ "/opt/app/client/src/site__fus078/components /index\\.js$/":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./adaptive-form-fields/index.js": "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/adaptive-form-fields/index.js",
	"./base-behaviour/index.js": "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/base-behaviour/index.js",
	"./blocks/audio/index.js": "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/blocks/audio/index.js",
	"./blocks/gallery/index.js": "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/blocks/gallery/index.js",
	"./blocks/icon/index.js": "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/blocks/icon/index.js",
	"./blocks/modal/index.js": "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/blocks/modal/index.js",
	"./blocks/video/index.js": "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/blocks/video/index.js",
	"./careers/index.js": "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/careers/index.js",
	"./contact-form/index.js": "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/contact-form/index.js",
	"./current-year/index.js": "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/current-year/index.js",
	"./custom-dropdown/index.js": "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/custom-dropdown/index.js",
	"./file-upload-field/index.js": "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/file-upload-field/index.js",
	"./hamburger-button/index.js": "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/hamburger-button/index.js",
	"./index.js": "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/index.js",
	"./lazy-iframe/index.js": "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/lazy-iframe/index.js",
	"./scroll-to-section/index.js": "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/scroll-to-section/index.js",
	"./search/global-search/index.js": "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/search/global-search/index.js",
	"./search/index.js": "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/search/index.js",
	"./search/results-filter/index.js": "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/search/results-filter/index.js",
	"./search/search-dropdown/index.js": "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/search/search-dropdown/index.js",
	"./share-button/index.js": "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/share-button/index.js",
	"./site-header/header/index.js": "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/site-header/header/index.js",
	"./site-header/index.js": "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/site-header/index.js",
	"./sliders/index.js": "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/sliders/index.js",
	"./subscription-form/index.js": "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/subscription-form/index.js",
	"./svg-animation/index.js": "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/svg-animation/index.js",
	"./video-background/index.js": "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/video-background/index.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/opt/app/client/src/site__fus078/components /index\\.js$/";

/***/ }),

/***/ "/opt/app/client/src/site__fus078/icons /\\.svg$/":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./brand-definition.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/brand-definition.svg",
	"./burger-close.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/burger-close.svg",
	"./burger.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/burger.svg",
	"./change-management.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/change-management.svg",
	"./character-clientservices.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/character-clientservices.svg",
	"./character-operations.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/character-operations.svg",
	"./character_creative.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/character_creative.svg",
	"./character_strategy.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/character_strategy.svg",
	"./character_technology.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/character_technology.svg",
	"./character_you.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/character_you.svg",
	"./chevron-down.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/chevron-down.svg",
	"./chevron-left.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/chevron-left.svg",
	"./chevron-right.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/chevron-right.svg",
	"./chevron-up.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/chevron-up.svg",
	"./close.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/close.svg",
	"./cms.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/cms.svg",
	"./conversion-rate.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/conversion-rate.svg",
	"./devop-consulting.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/devop-consulting.svg",
	"./digital-insights.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/digital-insights.svg",
	"./digital-strategy.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/digital-strategy.svg",
	"./download.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/download.svg",
	"./email-alt.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/email-alt.svg",
	"./episerver-logo.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/episerver-logo.svg",
	"./error.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/error.svg",
	"./external-link.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/external-link.svg",
	"./facebook-alt.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/facebook-alt.svg",
	"./facebook.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/facebook.svg",
	"./fusion-logo.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/fusion-logo.svg",
	"./icon-awardwinning.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-awardwinning.svg",
	"./icon-blog.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-blog.svg",
	"./icon-casestudies.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-casestudies.svg",
	"./icon-clientleader.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-clientleader.svg",
	"./icon-cog.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-cog.svg",
	"./icon-design.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-design.svg",
	"./icon-designer.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-designer.svg",
	"./icon-developer.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-developer.svg",
	"./icon-deviceagnostic.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-deviceagnostic.svg",
	"./icon-easyintegration.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-easyintegration.svg",
	"./icon-efficient.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-efficient.svg",
	"./icon-engaging.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-engaging.svg",
	"./icon-error.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-error.svg",
	"./icon-fast.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-fast.svg",
	"./icon-mobilepayments.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-mobilepayments.svg",
	"./icon-nativeapps.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-nativeapps.svg",
	"./icon-news.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-news.svg",
	"./icon-personalised.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-personalised.svg",
	"./icon-secure.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-secure.svg",
	"./icon-seo.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-seo.svg",
	"./icon-simple.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-simple.svg",
	"./icon-speed.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-speed.svg",
	"./icon-strategist.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-strategist.svg",
	"./icon-strategy.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-strategy.svg",
	"./icon-tech.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-tech.svg",
	"./icon-vr.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-vr.svg",
	"./icon-you.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-you.svg",
	"./icon_calendar.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon_calendar.svg",
	"./icon_developers.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon_developers.svg",
	"./icon_mail.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon_mail.svg",
	"./icon_network.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon_network.svg",
	"./icon_pencil.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon_pencil.svg",
	"./icon_people.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon_people.svg",
	"./icon_web_page.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon_web_page.svg",
	"./info.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/info.svg",
	"./instagram.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/instagram.svg",
	"./link-next.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/link-next.svg",
	"./link-prev.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/link-prev.svg",
	"./linkedin-alt.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/linkedin-alt.svg",
	"./linkedin.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/linkedin.svg",
	"./medium.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/medium.svg",
	"./minus.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/minus.svg",
	"./mobile-app.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/mobile-app.svg",
	"./pause.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/pause.svg",
	"./pdf.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/pdf.svg",
	"./pin.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/pin.svg",
	"./play-round.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/play-round.svg",
	"./play.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/play.svg",
	"./plus.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/plus.svg",
	"./prototyping.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/prototyping.svg",
	"./quote.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/quote.svg",
	"./quotemark.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/quotemark.svg",
	"./related-blog.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/related-blog.svg",
	"./related-news.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/related-news.svg",
	"./related-work.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/related-work.svg",
	"./responsive.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/responsive.svg",
	"./search.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/search.svg",
	"./services-creative.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/services-creative.svg",
	"./services-operations.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/services-operations.svg",
	"./services-strategy.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/services-strategy.svg",
	"./services-technology.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/services-technology.svg",
	"./share.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/share.svg",
	"./sound.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/sound.svg",
	"./spinner.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/spinner.svg",
	"./success.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/success.svg",
	"./tick.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/tick.svg",
	"./title-playtowin.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/title-playtowin.svg",
	"./twitter-alt.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/twitter-alt.svg",
	"./twitter.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/twitter.svg",
	"./upload-cloud.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/upload-cloud.svg",
	"./user-centred.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/user-centred.svg",
	"./user-experience.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/user-experience.svg",
	"./vimeo.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/vimeo.svg",
	"./youtube.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/youtube.svg",
	"./zoom.svg": "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/zoom.svg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/opt/app/client/src/site__fus078/icons /\\.svg$/";

/***/ }),

/***/ "/opt/app/client/src/site__fus078/polyfills nonrecursive /.*\\.polyfill.js$/":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./svg.polyfill.js": "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/polyfills/svg.polyfill.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/opt/app/client/src/site__fus078/polyfills nonrecursive /.*\\.polyfill.js$/";

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/adaptive-form-fields/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var ELEMENT_SELECTOR = '[data-adaptive-field]';

$(document).on('ready markupLoaded', function () {
	var $element = $(ELEMENT_SELECTOR);
	if ($element && $element.length > 0) {
		__webpack_require__.e/* import() */("components/adaptiveFields").then(__webpack_require__.bind(null, "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/adaptive-form-fields/component.js")).then(function (_ref) {
			var adaptiveField = _ref.adaptiveField;

			// console.log('adaptiveField', adaptiveField);
			$element.each(function (index, element) {
				new adaptiveField(element);
			});
		});
	}
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js")))

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/base-behaviour/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, $script) {

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.BaseAjaxRecaptchaForm = exports.BaseAjaxForm = exports.Base = undefined;

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _debug = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _debug2.default)('fus078/components/base-behaviour');

var Base = exports.Base = function () {
	function Base(element, options) {
		_classCallCheck(this, Base);

		this.element = element;
		this.$element = $(element);
		this.options = Base.mapAttributeOptions(this.constructor.componentName, Object.assign({}, this.constructor.DEFAULTS, options), this.$element.data());
		this.$element.data(this.constructor.componentName, this);
		log('attaching', this.element, this.$element, this.options);
	}

	_createClass(Base, null, [{
		key: 'mapAttributeOptions',
		value: function mapAttributeOptions(name, defaults, dataset) {
			var options = Object.keys(dataset).reduce(function (result, key) {
				result[key.toLowerCase().replace(name + '-', '')] = dataset[key];
				return result;
			}, {});
			return Object.assign({}, defaults, options);
		}
	}]);

	return Base;
}();

var BaseAjaxForm = exports.BaseAjaxForm = function (_Base) {
	_inherits(BaseAjaxForm, _Base);

	function BaseAjaxForm(element, options) {
		_classCallCheck(this, BaseAjaxForm);

		var _this = _possibleConstructorReturn(this, (BaseAjaxForm.__proto__ || Object.getPrototypeOf(BaseAjaxForm)).call(this, element, options));

		_this.$form = $(_this.options.formselector, _this.$element);
		_this.$submitButton = $(_this.options.submitbuttonselector, _this.$element);
		_this.$messages = {
			wait: $(_this.options.messagewaitselector, _this.$element),
			error: $(_this.options.messageerrorselector, _this.$element),
			success: $(_this.options.messagesuccessselector, _this.$element)
		};

		if (_this.attachValidation && typeof _this.attachValidation == 'function') {
			__webpack_require__.e/* import() */("vendor/jquery.validate@1.11.1").then(__webpack_require__.bind(null, "/opt/app/client/src/vendor/jquery.validate@1.11.1.js")).then(_this.attachValidation.bind(_this));
		} else {
			console && console.warn(_this.constructor.name + ' missing attachValidation method!');
		}

		_this.preflight = {
			'submit-enabled': function submitEnabled() {
				return !_this.$submitButton.attr('disabled');
			},
			'form-valid': function formValid() {
				return _this.$form.valid();
			}
		};

		_this.$submitButton.on('click', _this.submit.bind(_this));

		_this.hideMessage('wait');
		_this.hideMessage('error');
		_this.hideMessage('success');
		return _this;
	}

	_createClass(BaseAjaxForm, [{
		key: 'compilePayload',
		value: function compilePayload() {
			return this.$element.find(this.options.payloaditemselector).map(function (index, item) {
				var field = $(item);
				return { name: field.attr('name'), value: field.val() };
			}).toArray().reduce(function (payload, _ref) {
				var name = _ref.name,
				    value = _ref.value;

				payload[name] = value;
				return payload;
			}, {});
		}
	}, {
		key: 'success',
		value: function success() {
			log('sucess');
			this.$form.hide();

			this.hideMessage('wait');
			this.hideMessage('error');
			this.showMessage('success');
			// window.scrollTo(0, 0);
		}
	}, {
		key: 'error',
		value: function error(msg) {
			log('error', { msg: msg });
			this.hideMessage('wait');
			this.hideMessage('success');
			this.showMessage('error');
		}
	}, {
		key: 'wait',
		value: function wait() {
			log('wait');
			this.showMessage('wait');
			this.hideMessage('error');
			this.hideMessage('success');
		}
	}, {
		key: 'getMessageElement',
		value: function getMessageElement(type) {
			if (!type || !this.$messages[type] || !this.$messages[type].length) return;
			return this.$messages[type];
		}
	}, {
		key: 'showMessage',
		value: function showMessage(type) {
			var timeoutMs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;

			var $messageElement = this.getMessageElement(type);
			if ($messageElement) {
				$messageElement.show();
			}
		}
	}, {
		key: 'hideMessage',
		value: function hideMessage(type) {
			if (!type || !this.$messages[type]) return;
			var $messageElement = this.$messages[type];
			$messageElement.hide();
		}
	}, {
		key: 'preflightCheck',
		value: function preflightCheck(readyFn) {
			var _this2 = this;

			log('preflightCheck');
			var notReady = Object.keys(this.preflight).map(function (key) {
				try {
					var result = _this2.preflight[key]();
					log('preflightCheck.' + key, result);
					return result;
				} catch (err) {
					log('preflightCheck.' + key + '.fail', { err: err });
					return false;
				}
			}).some(function (result) {
				return result == false;
			});
			if (!notReady) {
				readyFn && readyFn();
			} else {
				log('preflightCheck.notReady');

				this.hideMessage('wait');
				this.hideMessage('error');
				this.hideMessage('success');
			}
		}
	}, {
		key: 'submit',
		value: function submit(event) {
			var _this3 = this;

			event.preventDefault();
			this.wait();
			this.preflightCheck(function () {
				log('BaseAjaxForm.submit.send');
				_this3.send();
			});
		}
	}, {
		key: 'send',
		value: function send() {
			var _this4 = this;

			var payload = this.compilePayload();
			var token = this.$form.find('input[name="__RequestVerificationToken"]').val();
			var headers = { "X-RVT": token };

			$.ajax({
				url: this.$form.attr('action'),
				type: 'POST',
				data: payload,
				headers: headers,
				success: function success(data, response) {
					_this4.$submitButton.removeAttr('disabled');
					if (data) {
						_this4.success();
					} else {
						_this4.error();
					}
				}
			});
		}
	}]);

	return BaseAjaxForm;
}(Base);

var BaseAjaxRecaptchaForm = exports.BaseAjaxRecaptchaForm = function (_BaseAjaxForm) {
	_inherits(BaseAjaxRecaptchaForm, _BaseAjaxForm);

	function BaseAjaxRecaptchaForm(element, options) {
		_classCallCheck(this, BaseAjaxRecaptchaForm);

		var _this5 = _possibleConstructorReturn(this, (BaseAjaxRecaptchaForm.__proto__ || Object.getPrototypeOf(BaseAjaxRecaptchaForm)).call(this, element, options));

		_this5.$recaptchaElement = $(_this5.options.recaptchaelementselector, _this5.$element);
		$script(['//www.google.com/recaptcha/api.js?onload=ON_RECAPTCHA_READY&render=explicit'], 'recaptcha');
		$script.ready('recaptcha', _this5.attachRecaptcha.bind(_this5));
		return _this5;
	}

	_createClass(BaseAjaxRecaptchaForm, [{
		key: 'recaptchaResponse',
		value: function recaptchaResponse(token) {
			this.send(token);
		}
	}, {
		key: 'recaptchaExpired',
		value: function recaptchaExpired() {
			window.grecaptcha.reset();
		}
	}, {
		key: 'recaptchaError',
		value: function recaptchaError() {
			this.hideMessage('wait');
			this.hideMessage('success');
			this.showMessage('error');
		}
	}, {
		key: 'compilePayload',
		value: function compilePayload() {
			var payload = _get(BaseAjaxRecaptchaForm.prototype.__proto__ || Object.getPrototypeOf(BaseAjaxRecaptchaForm.prototype), 'compilePayload', this).call(this);
			return Object.assign({}, payload, {
				"recaptchaResponse": grecaptcha.getResponse(this.recaptchaId)
			});
		}
	}, {
		key: 'attachRecaptcha',
		value: function attachRecaptcha() {
			var _this6 = this;

			ON_RECAPTCHA_READY.ready(function () {
				if (_this6.recaptchaReady) {
					return;
				}
				var element = _this6.$recaptchaElement.get(0);

				if (element) {
					_this6.recaptchaId = window.grecaptcha.render(element, {
						'sitekey': _this6.options.recaptchasitekey,
						'callback': _this6.recaptchaResponse.bind(_this6),
						'expired-callback': _this6.recaptchaExpired.bind(_this6),
						'error-callback': _this6.recaptchaError.bind(_this6),
						'size': _this6.options.recaptchasize
					});
					_this6.recaptchaReady = true;
					_this6.$submitButton.attr('disabled', false);
					log('recaptcha.attached', _this6);
				}
			});
		}
	}, {
		key: 'submit',
		value: function submit(event) {
			var _this7 = this;

			event.preventDefault();

			this.showMessage('wait');
			this.hideMessage('error');
			this.hideMessage('success');

			this.preflightCheck(function () {
				log('BaseAjaxRecaptchaForm.submit.executeRecaptcha');
				grecaptcha.execute(_this7.recaptchaId);
			});
		}
	}]);

	return BaseAjaxRecaptchaForm;
}(BaseAjaxForm);

function ON_RECAPTCHA_READY() {
	log('ON_RECAPTCHA_READY');
	ON_RECAPTCHA_READY.isReady = true;
	ON_RECAPTCHA_READY.fns.forEach(function (fn) {
		return fn();
	});
};
ON_RECAPTCHA_READY.fns = [];
ON_RECAPTCHA_READY.ready = function (fn) {
	ON_RECAPTCHA_READY.fns.push(fn);
};
ON_RECAPTCHA_READY.isReady = false;
window.ON_RECAPTCHA_READY = ON_RECAPTCHA_READY;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js"), __webpack_require__("/opt/app/client/src/vendor/script@2.5.8.js")))

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/blocks/audio/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-audio-player]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'audioPlayer';

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
    var element = this;
    __webpack_require__.e/* import() */("../../../../../../node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/blocks/audio/audio-player.js_../../../../../../../node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/blocks/audio/media-player/media-player@2.0.0.js_../../babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/babel-polyfill/lib/index.js_../../../babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/core-js/fn/regexp/escape.js_../babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/regenerator-runtime/runtime.js").then(__webpack_require__.bind(null, "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/blocks/audio/audio-player.js")).then(function () {
      (0, _jquery2.default)(element)[PLUGIN_NAME]();
    });
  });
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/blocks/gallery/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
		value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-image-gallery]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'imageGallery';

(0, _jquery2.default)(document).ready(function () {
		(0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
				var element = this;
				__webpack_require__.e/* import() */("components/gallery").then(__webpack_require__.bind(null, "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/blocks/gallery/component.js")).then(function () {
						(0, _jquery2.default)(element)[PLUGIN_NAME]();
				});
		});
});

console.log("HELLO!");

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/blocks/icon/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

// import $ from 'jquery';

$(function () {
	var $elements = $('.icon-large');
	if ($elements && $elements.length > 0) {

		__webpack_require__.e/* import() */("vendor/jquery.fittext@1.2").then(__webpack_require__.bind(null, "/opt/app/client/src/vendor/jquery.fittext@1.2.js")).then(function () {
			$('.icon-large').fitText(0.15);
		});
	}
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js")))

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/blocks/modal/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _debug = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('fus078/components/modal-block');

var ELEMENT_SELECTOR = '[data-modal]';

$(document).on('ready markupLoaded', function () {
	var $element = $(ELEMENT_SELECTOR);
	if ($element && $element.length > 0) {
		__webpack_require__.e/* import() */("vendor/ModalWindowEffects/js/modalEffects").then(__webpack_require__.bind(null, "/opt/app/client/src/vendor/ModalWindowEffects/js/modalEffects.js")).then(function () {
			log("ModalWindowEffects.loaded");
		});
	}
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js")))

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/blocks/video/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

$(document).on('ready markupLoaded', function () {
	var $element = $("[data-videoblock]");

	if ($element && $element.length > 0) {
		__webpack_require__.e/* import() */("components/video-block").then(__webpack_require__.bind(null, "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/blocks/video/component.js")).then(function (_ref) {
			var videoBlock = _ref.videoBlock;

			$element.each(function (index, element) {
				new videoBlock(element);
			});
		});
	}
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js")))

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/careers/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ELEMENT_SELECTOR = undefined;

var _debug = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('fus078/components/contact-form');

log('load');

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-career-application-form]';

$(function () {

	var $element = $(ELEMENT_SELECTOR);
	if ($element && $element.length) {
		log('mount.plugin', $element);

		__webpack_require__.e/* import() */("components/adaptiveFields").then(__webpack_require__.bind(null, "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/careers/component.js")).then(function (_ref) {
			var careerApplicationForm = _ref.careerApplicationForm;

			$element.each(function (index, element) {
				return new careerApplicationForm(element);
			});
		});
	}
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js")))

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/contact-form/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ELEMENT_SELECTOR = undefined;

var _debug = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('fus078/components/contact-form');

log('load');

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-contact-form]';

$(document).on('ready markupLoaded', function () {
	var $element = $(ELEMENT_SELECTOR);
	if ($element && $element.length > 0) {
		log('mount.plugin', $element);

		__webpack_require__.e/* import() */("components/contactForm").then(__webpack_require__.bind(null, "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/contact-form/component.js")).then(function (_ref) {
			var contactForm = _ref.contactForm;

			// console.log('adaptiveField', adaptiveField);
			$element.each(function (index, element) {
				return new contactForm(element);
			});
		});
	}
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js")))

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/current-year/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

// import $ from 'jquery';

$(function () {
	var $element = $('#currentYear');
	if ($element && $element.length > 0) {
		$element.html(new Date().getFullYear());
	}
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js")))

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/custom-dropdown/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

// import $ from 'jquery';

function DropDown(el) {
    this.dd = el;
    this.placeholder = this.dd.children('span');
    this.opts = this.dd.find('ul.dropdown > li');
    this.val = '';
    this.index = -1;
    console && console.warn('Untested.Code', el);
    this.initEvents();
}

DropDown.prototype = {
    initEvents: function initEvents() {
        var obj = this;

        obj.dd.on('click', function (event) {
            $(this).toggleClass('active');
            return false;
        });

        obj.opts.on('click', function () {
            var opt = $(this);
            obj.val = opt.text();
            obj.index = opt.index();
            obj.placeholder.text(obj.val);
        });
    },
    getValue: function getValue() {
        return this.val;
    },
    getIndex: function getIndex() {
        return this.index;
    }
};

$(function () {

    var dd = new DropDown($('#dd'));

    $(document).click(function () {
        // all dropdowns
        $('.blog-filter').removeClass('active');
    });

    $(".dropdown li").on("click", function (e) {
        $(this).addClass("filter-selected").siblings().removeClass("filter-selected");
    });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js")))

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/file-upload-field/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var ELEMENT_SELECTOR = '[data-fileuploader]';

$(document).on('ready markupLoaded', function () {
	var $element = $(ELEMENT_SELECTOR);
	if ($element && $element.length > 0) {
		__webpack_require__.e/* import() */("components/fileUploadField").then(__webpack_require__.bind(null, "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/file-upload-field/component.js")).then(function (_ref) {
			var fileUploader = _ref.fileUploader;

			$element.each(function (index, element) {
				new fileUploader(element);
			});
		});
	}
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js")))

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/hamburger-button/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

// import $ from 'jquery';


$(function () {

	$('.hamburger').click(function () {
		$(this).toggleClass('is-active');
		$('.header').toggleClass('hamburger-is-active');
		$('.internal-header').toggleClass('hamburger-is-active');
	});
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js")))

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _debug = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('fus078/components');

var files = __webpack_require__("/opt/app/client/src/site__fus078/components /index\\.js$/");
files.keys().forEach(files);

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/lazy-iframe/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-lazy-iframe]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'lazyIframe';

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
    var element = this;
    __webpack_require__.e/* import() */("component--lazy-iframe").then(__webpack_require__.bind(null, "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/lazy-iframe/lazy-iframe.js")).then(function () {
      (0, _jquery2.default)(element)[PLUGIN_NAME]();
    });
  });
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/scroll-to-section/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

// import $ from 'jquery';

$(function () {

	__webpack_require__.e/* import() */("vendor/jquery.scrolldepth@0.6").then(__webpack_require__.bind(null, "/opt/app/client/src/vendor/jquery.scrolldepth@0.6.js")).then(function () {

		$.scrollDepth({
			minHeight: 2000,
			elements: ['.partners', '#clients', '#testimonials', '#careers', '#contact', '#contact-form', 'footer'],
			percentage: true,
			userTiming: true,
			pixelDepth: true,
			nonInteraction: true
		});
	});

	$('a.scroll').click(function () {
		var currentLocation = location.pathname.replace(/^\//, '');

		if (currentLocation == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			if (target.length) {
				if ($('#header').hasClass('hamburger-is-active')) {
					$('.hamburger').toggleClass('is-active');
					$('#header').toggleClass('hamburger-is-active');
				}
				var offset = target.offset().top - 90;
				$('html,body').animate({
					scrollTop: offset
				}, 1000);
				return false;
			} else {
				var parentSection = $(this).closest('section');
				target = $(parentSection).next('section');
				if (target.length) {
					var offset = target.offset().top - 90;
					$('html,body').animate({
						scrollTop: offset
					}, 1000);
					return false;
				}
			}
		}
	});
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js")))

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/search/global-search/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/search/global-search/search-form-collapsible.js");

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/search/global-search/search-form-collapsible.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-search-form-collapsible]';
var PLUGIN_NAME = 'searchFormCollapsible';

var log = (0, _debug2.default)('site-header/header-controller:search');

var SearchFormCollapsible = function () {
	function SearchFormCollapsible(element, options) {
		_classCallCheck(this, SearchFormCollapsible);

		log('element', element);
		log('options', options);

		this.options = options;
		this.element = element;
		this.$element = (0, _jquery2.default)(element);

		this.enabled = false;

		this.formElements = this.selectors.selectTarget(this.options.elementsSelector, this.$element);

		this.watch();

		log('ready', this, this.$target);
	}

	_createClass(SearchFormCollapsible, [{
		key: 'watch',
		value: function watch() {
			log('watching');

			this.$element.on('togglesearch', this.toggle.bind(this));
			this.$element.on('disablesearch', this.disable.bind(this));
		}
	}, {
		key: 'enable',
		value: function enable() {
			this.formElements.removeAttr('disabled');
			this.enabled = true;
			this.formElements[0].focus();
			log('enable');
		}
	}, {
		key: 'disable',
		value: function disable() {
			this.formElements.attr('disabled', 'disabled');
			this.enabled = false;
			log('disable');
		}
	}, {
		key: 'toggle',
		value: function toggle() {
			var handler = this.enabled ? this.disable.bind(this) : this.enable.bind(this);
			log('toggle');
			handler();
		}
	}]);

	return SearchFormCollapsible;
}();

SearchFormCollapsible.DEFAULTS = {};

(0, _lib2.default)(PLUGIN_NAME, SearchFormCollapsible);

(0, _jquery2.default)(document).ready(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/search/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/search/results-filter/index.js");

__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/search/search-dropdown/index.js");

__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/search/global-search/index.js");

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/search/results-filter/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/search/results-filter/search-results-filter-panel.js");

__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/search/results-filter/search-filter-date.js");

__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/search/results-filter/search-filter-date-range.js");

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/search/results-filter/search-filter-date-range.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-search-filter-date-range]';
var PLUGIN_NAME = 'searchFilterDateRange';

var log = (0, _debug2.default)('search/results-filter/search-filter-date:range');

var SearchFilterDateRange = function () {
	function SearchFilterDateRange(element, options) {
		_classCallCheck(this, SearchFilterDateRange);

		log('element', element);
		log('options', options);

		this.options = options;
		this.element = element;
		this.$element = (0, _jquery2.default)(element);

		this.form = this.selectors.selectTarget('(parents) form', this.$element);

		this.allCheckbox = this.selectors.selectTarget(this.options.allCheckboxSelector, this.$element);

		this.dateComponents = this.selectors.selectTarget(this.options.dateComponentsSelector, this.$element);

		this.fromInput = this.selectors.selectTarget(this.options.fromInputSelector, this.$element);

		this.toInput = this.selectors.selectTarget(this.options.toInputSelector, this.$element);

		this.validationMessage = this.selectors.selectTarget(this.options.validationMessageSelector, this.$element);

		this.watch();

		log('ready', this);
	}

	_createClass(SearchFilterDateRange, [{
		key: 'watch',
		value: function watch() {
			log('watching');

			this.allCheckbox.on('change', this.onCheckboxChange.bind(this));

			this.form.on('submit', this.onSubmit.bind(this));

			//	'date-changed' event bubbled from child components
			this.$element.on('datechange', this.onDateChanged.bind(this));
		}
	}, {
		key: 'isUnfiltered',
		value: function isUnfiltered(from, to) {
			return !from && !to;
		}
	}, {
		key: 'isFullDate',
		value: function isFullDate(date) {
			return date.length === 6;
		}
	}, {
		key: 'hasDateRange',
		value: function hasDateRange(fromDate, toDate) {
			return this.isFullDate(fromDate) && this.isFullDate(toDate);
		}
	}, {
		key: 'isValidDateRange',
		value: function isValidDateRange(from, to) {
			return from <= to;
		}
	}, {
		key: 'onCheckboxChange',
		value: function onCheckboxChange() {
			if (this.allCheckbox.is(':checked')) {
				this.dateComponents.searchFilterDate('reset');
			}
		}
	}, {
		key: 'shouldDisplayRangeError',
		value: function shouldDisplayRangeError(fromValue, toValue) {

			if (!this.hasDateRange(fromValue, toValue)) {
				return false;
			}

			return !this.isValidDateRange(fromValue, toValue);
		}
	}, {
		key: 'updateValidation',
		value: function updateValidation(fromValue, toValue) {
			if (this.shouldDisplayRangeError(fromValue, toValue)) {
				this.validationMessage.removeAttr('hidden');
			} else {
				this.validationMessage.attr('hidden', 'hidden');
			}
		}
	}, {
		key: 'onDateChanged',
		value: function onDateChanged() {
			var from = this.fromInput[0].value;
			var to = this.toInput[0].value;
			this.allCheckbox.prop('checked', this.isUnfiltered(from, to));
			this.updateValidation(from, to);
		}
	}, {
		key: 'onSubmit',
		value: function onSubmit(event) {
			var from = this.fromInput[0].value;
			var to = this.toInput[0].value;
			var isInvalid = this.shouldDisplayRangeError(from, to);

			this.updateValidation(from, to);

			if (isInvalid) {
				event.preventDefault();
			}
		}
	}]);

	return SearchFilterDateRange;
}();

SearchFilterDateRange.DEFAULTS = {};
(0, _lib2.default)(PLUGIN_NAME, SearchFilterDateRange);

(0, _jquery2.default)(document).ready(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/search/results-filter/search-filter-date.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-search-filter-date]';
var PLUGIN_NAME = 'searchFilterDate';

var log = (0, _debug2.default)('search/results-filter/search-filter-date:date');

var SearchFilterDate = function () {
	function SearchFilterDate(element, options) {
		_classCallCheck(this, SearchFilterDate);

		log('element', element);
		log('options', options);

		this.options = options;
		this.element = element;
		this.$element = (0, _jquery2.default)(element);

		this.form = this.selectors.selectTarget('(parents) form', this.$element);

		this.monthSelect = this.selectors.selectTarget(this.options.monthSelectSelector, this.$element);

		this.yearSelect = this.selectors.selectTarget(this.options.yearSelectSelector, this.$element);

		this.valueInput = this.selectors.selectTarget(this.options.valueInputSelector, this.$element);

		this.validationMessage = this.selectors.selectTarget(this.options.validationMessageSelector, this.$element);

		this.watch();

		log('ready', this, this.$target);
	}

	_createClass(SearchFilterDate, [{
		key: 'watch',
		value: function watch() {
			log('watching');

			this.form.on('submit', this.onSubmit.bind(this));

			this.monthSelect.on('change', this.onChange.bind(this));
			this.yearSelect.on('change', this.onChange.bind(this));
		}
	}, {
		key: 'hasValue',
		value: function hasValue(month, year) {
			var hasMonth = month !== '0';
			var hasYear = year !== '0';

			return hasMonth || hasYear;
		}
	}, {
		key: 'isValid',
		value: function isValid(month, year) {
			var hasMonth = month !== '0';
			var hasYear = year !== '0';

			return hasMonth && hasYear || !hasMonth && !hasYear;
		}
	}, {
		key: 'updateValidation',
		value: function updateValidation(month, year) {
			var shouldDisplay = !this.isValid(month, year);
			if (shouldDisplay) {
				this.validationMessage.removeAttr('hidden');
			} else {
				this.validationMessage.attr('hidden', 'hidden');
			}
		}
	}, {
		key: 'updateValue',
		value: function updateValue(month, year) {
			var newValue = this.hasValue(month, year) ? '' + year + month : '';
			this.valueInput.val(newValue);
		}

		// trigger this method from parent date range

	}, {
		key: 'reset',
		value: function reset() {
			this.monthSelect.val('0');
			this.yearSelect.val('0');
			this.updateValue('0', '0');
			this.updateValidation('0', '0');
		}
	}, {
		key: 'onChange',
		value: function onChange() {
			var monthValue = this.monthSelect.val();
			var yearValue = this.yearSelect.val();
			var isValid = this.isValid(monthValue, yearValue);

			// Don't show validation errors before submiting
			if (isValid) {
				this.updateValidation(monthValue, yearValue);
			}

			// update here to update All dates checkbox immediately
			this.updateValue(monthValue, yearValue);

			this.$element.trigger('datechange');
		}
	}, {
		key: 'onSubmit',
		value: function onSubmit(event) {
			log('submit');
			var monthValue = this.monthSelect.val();
			var yearValue = this.yearSelect.val();
			var isValid = this.isValid(monthValue, yearValue);

			// these may be redundant as they will have been called onChange?
			this.updateValidation(monthValue, yearValue);
			this.updateValue(monthValue, yearValue);

			if (!isValid) {
				event.preventDefault();
			}
		}
	}]);

	return SearchFilterDate;
}();

SearchFilterDate.DEFAULTS = {};

(0, _lib2.default)(PLUGIN_NAME, SearchFilterDate);

(0, _jquery2.default)(document).ready(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/search/results-filter/search-results-filter-panel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('components/search/search-result-filter-panel');
var select = {
	ALL_CHECKBOX: '[data-search-filter-panel__choice-all]',
	CHOICE_CHECKBOX: '[data-search-filter-panel__choice]',
	FILTER_GROUP: '[data-search-filter-panel__group]',
	VALUE_INPUT: '[data-search-filter-panel__group-values]'
};

(0, _jquery2.default)(function () {
	(0, _jquery2.default)(select.ALL_CHECKBOX).on('change', function () {
		if (!this || !this.checked) {
			return;
		}
		var allCheckbox = (0, _jquery2.default)(this);
		var thisGroup = allCheckbox.parents(select.FILTER_GROUP);
		var allOptions = thisGroup.find(select.CHOICE_CHECKBOX);
		var valueInput = thisGroup.find(select.VALUE_INPUT);

		allOptions.each(function (index, choice) {
			choice.checked = false;
		});

		valueInput.val('');
	});

	(0, _jquery2.default)(select.CHOICE_CHECKBOX).on('change', function () {
		var thisOption = (0, _jquery2.default)(this);
		var thisGroup = thisOption.parents(select.FILTER_GROUP);
		var allCheckbox = thisGroup.find(select.ALL_CHECKBOX);
		var allOptions = thisGroup.find(select.CHOICE_CHECKBOX);
		var valueInput = thisGroup.find(select.VALUE_INPUT);

		var collatedValue = allOptions.filter(':checked').map(function (index, input) {
			return input.value;
		}).get().join();

		allCheckbox.prop('checked', false);
		valueInput.val(collatedValue);
	});

	log('mounted');
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/search/search-dropdown/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-search-dropdown]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'SearchDropdown';

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
    var element = this;
    __webpack_require__.e/* import() */("plugin--search-dropdown").then(__webpack_require__.bind(null, "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/search/search-dropdown/plugin.js")).then(function () {
      (0, _jquery2.default)(element)[PLUGIN_NAME]();
    });
  });
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/share-button/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

// import $ from 'jquery';

$(function () {

	$(".share-toggle-button").on("click", function (event) {
		event.stopPropagation();
		$(this).parent().toggleClass("is-active");
	});

	$('body').on('click', function (event) {
		$('#share-wrapper').removeClass('is-active');
	});
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js")))

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/site-header/header/header-controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-header-controller]';
var PLUGIN_NAME = 'headerController';

var log = (0, _debug2.default)('site-header/header-controller:header');

var HeaderController = function () {
	function HeaderController(element, options) {
		_classCallCheck(this, HeaderController);

		log('element', element);
		log('options', options);

		this.options = options;
		this.element = element;
		this.$element = (0, _jquery2.default)(element);

		this.isSearchCollapsible = !!this.options.searchComponentSelector;

		this.searchComponent = this.isSearchCollapsible && this.selectors.selectTarget(this.options.searchComponentSelector, this.$element);

		this.watch();

		log('ready', this, this.$target);
	}

	_createClass(HeaderController, [{
		key: 'watch',
		value: function watch() {
			log('watching');

			this.$element.on('concealsearch', this.tryConcealSearch.bind(this));
		}
	}, {
		key: 'tryConcealSearch',
		value: function tryConcealSearch() {
			log('attempting to disable search');
			if (this.isSearchCollapsible) {
				this.searchComponent.trigger('disablesearch');
			} else {
				log('Search is not collapsible');
			}
		}
	}]);

	return HeaderController;
}();

HeaderController.DEFAULTS = {};

(0, _lib2.default)(PLUGIN_NAME, HeaderController);

(0, _jquery2.default)(document).ready(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/site-header/header/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/site-header/header/header-controller.js");

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/site-header/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/site-header/header/index.js");

__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/site-header/navigation--obscurable.js");

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/site-header/navigation--obscurable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Obscurable Navigation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @original-idea Kate York
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @original-idea Oliver Boermans
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author Zenobius Jiricek
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @example
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * see ./header.scss
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

//
// Utilities


var _jquery = __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

var _selectors = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/lib/selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PLUGIN_NAME = "ObscurableNavigation";
var ELEMENT_SELECTOR = "[data-navigation-obscurable]";
var log = (0, _debug2.default)('@fus078/components/site-header/navigation--obscurable');

var ObscurableNavigationPlugin = function () {
  function ObscurableNavigationPlugin(element) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, ObscurableNavigationPlugin);

    this.element = element;
    this.$element = (0, _jquery2.default)(element);
    this.options = options;
    this.options.tolerancePx = parseInt(this.options.tolerancePx);

    log('created', { element: element, options: this.options });
    this.components = {
      obscuredItemContainer: (0, _selectors.selectTarget)(this.options.obscuredItemContainerSelector, this.$element),
      visibleItemContainer: (0, _selectors.selectTarget)(this.options.visibleItemContainerSelector, this.$element),
      obscuredItemContainerToggle: (0, _selectors.selectTarget)(this.options.obscuredItemContainerToggleSelector, this.$element)
    };

    this.watch();
  }

  _createClass(ObscurableNavigationPlugin, [{
    key: 'watch',
    value: function watch() {
      var _this = this;

      log('watch');
      this.currentTestId = 0;
      (0, _jquery2.default)(window).resize(function () {
        _this.components.visibleItemContainer.addClass('testing');
      });
      (0, _jquery2.default)(window).resize(this.fn.debounce(this.test.bind(this), this.options.testTimeoutMs, true));
      (0, _jquery2.default)(window).resize(this.fn.debounce(this.test.bind(this), this.options.testTimeoutMs));
      setTimeout(this.test.bind(this), this.options.testTimeoutMs);
    }
  }, {
    key: 'test',
    value: function test() {
      log('test');
      this.unObscureItems();
      this.testItems();
    }
  }, {
    key: 'isItemObscured',
    value: function isItemObscured(element) {
      log('isItemObscured', element);
      var $testElement = (0, _jquery2.default)(element);
      var width = $testElement.outerWidth(true);
      var rightEdgePosition = width + this.options.tolerancePx + this.accumulatedWidth;
      var result = rightEdgePosition > this.actualContainerWidth;
      log('isItemObscured', rightEdgePosition, this.actualContainerWidth, result);
      this.accumulatedWidth += width;
      return result;
    }
  }, {
    key: 'unObscureItems',
    value: function unObscureItems() {
      var _this2 = this;

      log('unObscureItems');
      // Put everything back in main nav
      // to prepare for testing if they in fact fit.
      (0, _selectors.selectTarget)(this.options.intersectingItemSelector, this.components.obscuredItemContainer).removeClass(this.options.obscuredItemClasses).addClass(this.options.visibleItemClasses).each(function (index, element) {
        _this2.components.visibleItemContainer.append((0, _jquery2.default)(element).detach());
      });
    }
  }, {
    key: 'moveItem',
    value: function moveItem(element) {
      log('moveItem', element);
      var $element = (0, _jquery2.default)(element).detach();

      $element.addClass(this.options.obscuredItemClasses).removeClass(this.options.visibleItemClasses);

      this.components.obscuredItemContainer.append($element);

      $element.show();
    }
  }, {
    key: 'testItems',
    value: function testItems(items) {
      var _this3 = this;

      log('testItems');
      var toggleWidth = this.components.obscuredItemContainerToggle.innerWidth();
      this.components.obscuredItemContainerToggle.detach();

      // Move the items that don't fit back to mobile nav
      this.components.obscuredItemContainerToggle.show();
      var $items = (0, _selectors.selectTarget)(this.options.intersectingItemSelector, this.components.visibleItemContainer);
      log('testItems.items', $items);

      this.actualContainerWidth = this.components.visibleItemContainer.innerWidth();
      // build a list of items that don't fit
      this.accumulatedWidth = 0;
      var obscuredItems = $items.filter(function (index, element) {
        return _this3.isItemObscured(element);
      });
      log('testItems.obscuredItems', obscuredItems);

      // if at least one item doesn't fit
      if (!this.components.visibleItemContainer.is(':visible')) {
        $items.each(function (index, element) {
          return _this3.moveItem(element);
        });
      } else if (obscuredItems.length > 0) {
        // reduce width of container
        this.actualContainerWidth = this.actualContainerWidth - toggleWidth;
        log('testItems.atLeatOneObscured', this.actualContainerWidth);

        this.accumulatedWidth = 0;
        obscuredItems = $items
        // re-test visible items based on new container width
        .filter(function (index, element) {
          return _this3.isItemObscured(element);
        })
        // then move them
        .each(function (index, element) {
          return _this3.moveItem(element);
        });
      }

      if (obscuredItems.length > 0 || obscuredItems.length == $items.length) {
        this.components.visibleItemContainer.append(this.components.obscuredItemContainerToggle);
      }

      if (!this.components.obscuredItemContainer.children().length > 0) {
        this.components.obscuredItemContainerToggle.hide();
      }

      this.components.visibleItemContainer.removeClass('testing');
    }
  }]);

  return ObscurableNavigationPlugin;
}();

ObscurableNavigationPlugin.DEFAULTS = {
  tolerancePx: 40,
  testTimeoutMs: 150,
  reflowOnResize: true,
  visibleItemClasses: 'navigation__item--unobscured',
  obscuredItemClasses: 'navigation__item--obscured',
  visibleItemContainerSelector: '(children) [data-navigation--visible-items]',
  intersectingItemSelector: '(children) [data-navigation--intersecting-item]',
  obscuredItemContainerSelector: '(children) [data-navigation--obscured-items]',
  obscuredItemContainerToggleSelector: '(children) [data-navigation--obscured-items-toggle]'
};

(0, _lib2.default)(PLUGIN_NAME, ObscurableNavigationPlugin);

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/sliders/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _debug = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _flickity = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/flickity/js/index.js");

var _flickity2 = _interopRequireDefault(_flickity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import $ from 'jquery';
var log = (0, _debug2.default)('fus078/components/sliders');

$(function () {
	var $elements = $('[data-flickity]');
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js")))

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/subscription-form/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
	value: true
});
var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-subscribe-form]';

$(document).on('ready markupReady', function () {

	var $elements = $(ELEMENT_SELECTOR);
	if ($elements && $elements.length) {
		__webpack_require__.e/* import() */("components/subscription-form").then(__webpack_require__.bind(null, "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/subscription-form/component.js")).then(function (_ref) {
			var subscribeForm = _ref.subscribeForm;

			$elements.each(function (index, element) {
				return new subscribeForm(element);
			});
		});
	}
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js")))

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/svg-animation/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

(function () {

        $(document).ready(function () {

                var path = document.getElementById("services-strategy");
                // growCog("cog1", path);
                // rotateCog("cog1", path);
                // rotateCog("cog2", path);
                $('.animatedude').click(function () {
                        snap();
                });
        });

        function rotateCog(id, path) {
                var svgDoc = path.contentDocument; //get the inner DOM of alpha.svg
                var delta = svgDoc.getElementById(id); //get the inner element by id
                var animate = delta.getElementsByTagName("animateTransform")[0];

                var bbox = delta.getBBox();
                animate.setAttribute("from", "0 " + (bbox.x + bbox.width / 2) + " " + (bbox.y + bbox.height / 2));
                animate.setAttribute("to", "360 " + (bbox.x + bbox.width / 2) + " " + (bbox.y + bbox.height / 2));
        }

        function growCog(id, path) {
                // var svgDoc = path.contentDocument; //get the inner DOM of alpha.svg
                // var delta = svgDoc.getElementById(id); //get the inner element by id
                // var animate = delta.getElementsByTagName("animateTransform")[1];

                // var bbox = delta.getBBox();
                // animate.setAttribute("from", 1 + " " + 1);
                // animate.setAttribute("to",  1.5 + " " + 1.5);


        }

        function startCogAnimation(path) {
                var svgDoc = path.contentDocument; //get the inner DOM of alpha.svg
                var delta = svgDoc.getElementById('cog1'); //get the inner element by id
                var animate = delta.getElementsByTagName("animateTransform")[0];

                var delta2 = svgDoc.getElementById('cog2'); //get the inner element by id
                var animate2 = delta2.getElementsByTagName("animateTransform")[0];

                animate.beginElement();
                animate2.beginElement();
                delta = svgDoc.getElementById('strategy');

                delta.unpauseAnimations();
        }

        function endCogAnimation(path) {
                var svgDoc = path.contentDocument;

                var delta = svgDoc.getElementById('strategy');

                delta.pauseAnimations();
        }

        function snap() {

                var s = Snap("#snap");
                //lets draw 2 rects at position 100,100 and then reposition them
                Snap.load("../img/services_strategy.svg", onSVGLoaded);

                function onSVGLoaded(data) {
                        s.append(data);
                        var elem = s.select('#cog1');
                        elem.attr({ opacity: 0 });
                        rotationAnimation(s.select('#cog1'), 360, 82, 82, 5000);
                        // rotationAnimation(s.select('#cog2'), 360, 133,133,2000);


                        var matrix = new Snap.Matrix();
                        matrix.scale(1.2, 1.2);
                        // matrix.translate(0,0);
                        // matrix.rotate(360);

                        //   elem.animate({opacity:1},5000).animate({ transform: matrix }, 3000, mina.bounce);
                }
        }

        function rotationAnimation(elem, degrees, pointX, pointY, time) {
                var matrix = new Snap.Matrix();
                matrix.scale(1.2, 1.2);
                elem.stop();
                elem.animate({ opacity: 1 }, 5000).animate({ transform: "r" + [degrees, pointX, pointY] }, time, function () {
                        elem.attr({ transform: 'r0,' + pointX + ',' + pointY });
                        rotationAnimation(elem, degrees, pointX, pointY, time);
                });
        }

        function setSVGEvents(path) {
                var svgDoc = path.contentDocument; //get the inner DOM of alpha.svg
                var circle = svgDoc.getElementById('services-strategy-circle'); //get the inner element by id
                var cog1 = svgDoc.getElementById('cog1'); //get the inner element by id
                var cog2 = svgDoc.getElementById('cog2'); //get the inner element by id

                $(cog1).attr("class", "cog active");

                // $(circle).hover(function(){
                //     startCogAnimation(path);
                // });

                // $(circle).on('mouseenter', function() {startCogAnimation(path)});

                // $(circle).on('mouseleave', function() {endCogAnimation(path)});

                // $(cog1).on('mouseenter', function() {startCogAnimation(path);});

                // $(cog1).on('mouseleave', function() {endCogAnimation(path)});

                // $(cog2).on('mouseenter', function() {startCogAnimation(path)});

                // $(cog2).on('mouseleave', function() {endCogAnimation(path)});

                // $(cog1).hover(function(){
                //     startCogAnimation(path);
                // });

                // $(cog2).hover(function(){
                //     startCogAnimation(path);
                // });
        }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js")))

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/video-background/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _debug = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('fus078/components/video-background'); // import $ from 'jquery';

var ELEMENT_SELECTOR = '[data-videobackground]';

$(document).on('ready markupLoaded', function () {
	var $element = $(ELEMENT_SELECTOR);
	if ($element && $element.length > 0) {
		__webpack_require__.e/* import() */("components/fileUploadField").then(__webpack_require__.bind(null, "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/video-background/component.js")).then(function (_ref) {
			var videoBackground = _ref.videoBackground;

			$element.each(function (index, element) {
				new videoBackground(element);
			});
		});
	}
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js")))

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/device-detection.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

// import $ from 'jquery';

(function () {
    var platforms = {
        ios: /(ipad|iphone|ipod)/.test(navigator.userAgent.toLowerCase()),
        android: /android/i.test(navigator.userAgent.toLowerCase())
    };
    var html = $('html');

    Object.keys(platforms).forEach(function (platform) {
        platforms[platform] && html.addClass(platform);
    });
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js")))

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/icons/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/opt/app/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--4-0!/opt/app/node_modules/css-loader/index.js!/opt/app/node_modules/webfonts-loader/index.js??ref--4-2!/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/icons/icons__config.js");

/*
Svg Sprites

markup:
<svg class="some-class-name"
     role="img"
     aria-hidden="true"
     focusable="false">
    <title id="{{modifier_class}}">{{modifier_class}}</title>
    <desc id="{{modifier_class}}">{{modifier_class}}</desc>
  	<use xmlns:xlink="http://www.w3.org/1999/xlink"
         xlink:href="{{ asseturl '/static/theme/images/sprites.svg' }}#{{modifier_class}}"></use>
</svg>

title-playtowin - title-playtowin
character_creative - character_creative
character_strategy - character_strategy
character_technology - character_technology
character_you - character_you
character-clientservices - character-clientservices
character-operations - character-operations
episerver-logo - episerver-logo
fusion-logo - fusion-logo
icon_calendar - icon_calendar
icon_developers - icon_developers
icon_mail - icon_mail
icon_network - icon_network
icon_pencil - icon_pencil
icon_people - icon_people
icon_web_page - icon_web_page
icon-awardwinning - icon-awardwinning
icon-blog - icon-blog
icon-casestudies - icon-casestudies
icon-clientleader - icon-clientleader
icon-cog - icon-cog
icon-design - icon-design
icon-designer - icon-designer
icon-developer - icon-developer
icon-deviceagnostic - icon-deviceagnostic
icon-easyintegration - icon-easyintegration
icon-efficient - icon-efficient
icon-engaging - icon-engaging
icon-error - icon-error
icon-fast - icon-fast
icon-mobilepayments - icon-mobilepayments
icon-nativeapps - icon-nativeapps
icon-news - icon-news
icon-personalised - icon-personalised
icon-secure - icon-secure
icon-seo - icon-seo
icon-simple - icon-simple
icon-speed - icon-speed
icon-strategist - icon-strategist
icon-strategy - icon-strategy
icon-tech - icon-tech
icon-vr - icon-vr
icon-you - icon-you
play - play
quotemark - quotemark
related-blog - related-blog
related-news - related-news
related-work - related-work
services-creative - services-creative
services-operations - services-operations
services-strategy - services-strategy
services-technology - services-technology


Styleguide FUS078.Sprites
*/

// this hack requires all svgs in the current directory
// causing webpacks svg sprite loader to kick into action.
var files = __webpack_require__("/opt/app/client/src/site__fus078/icons /\\.svg$/");
files.keys().forEach(files);

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js");

__webpack_require__("/opt/app/client/src/vendor/script@2.5.8.js");

__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/icons/index.js");

__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/device-detection.js");

__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/vendor/index.js");

__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/polyfills/index.js");

__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/index.js");

__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/index.js");

__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/utilities/index.js");

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/jquery__toggle-element-classes/index.js");

__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/jquery__remove-element-classes/index.js");

__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/jquery__add-element-classes/index.js");

__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/jquery__focus-within/index.js");

__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/jquery__focus/index.js");

__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/jquery__emit-on-dirty/index.js");

__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/jquery__trigger-event/index.js");

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/jquery__add-element-classes/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-add-element-classes]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'AddElementClasses';

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
    var element = this;
    __webpack_require__.e/* import() */("plugin--add-element-classes").then(__webpack_require__.bind(null, "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/jquery__add-element-classes/plugin.js")).then(function () {
      (0, _jquery2.default)(element)[PLUGIN_NAME]();
    });
  });
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/jquery__emit-on-dirty/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-emit-on-dirty]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'EmitOnDirty';

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
    var element = this;
    __webpack_require__.e/* import() */("plugin--emit-on-dirty").then(__webpack_require__.bind(null, "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/jquery__emit-on-dirty/plugin.js")).then(function () {
      (0, _jquery2.default)(element)[PLUGIN_NAME]();
    });
  });
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/jquery__focus-within/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-focus-within]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'FocusWithin';

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
    var element = this;
    __webpack_require__.e/* import() */("plugin--focus-within").then(__webpack_require__.bind(null, "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/jquery__focus-within/plugin.js")).then(function () {
      (0, _jquery2.default)(element)[PLUGIN_NAME]();
    });
  });
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/jquery__focus/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-focus-element]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'FocusElement';

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
    var element = this;
    __webpack_require__.e/* import() */("plugin--focus-element").then(__webpack_require__.bind(null, "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/jquery__focus/plugin.js")).then(function () {
      (0, _jquery2.default)(element)[PLUGIN_NAME]();
    });
  });
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/jquery__remove-element-classes/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-remove-element-classes]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'RemoveElementClasses';

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
    var element = this;
    __webpack_require__.e/* import() */("plugin--remove-element-classes").then(__webpack_require__.bind(null, "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/jquery__remove-element-classes/plugin.js")).then(function () {
      (0, _jquery2.default)(element)[PLUGIN_NAME]();
    });
  });
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/jquery__toggle-element-classes/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-toggle-element-classes]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'ToggleElementClasses';

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
    var element = this;
    __webpack_require__.e/* import() */("plugin--toggle-element-classes").then(__webpack_require__.bind(null, "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/jquery__toggle-element-classes/plugin.js")).then(function () {
      (0, _jquery2.default)(element)[PLUGIN_NAME]();
    });
  });
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/jquery__trigger-event/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-trigger-event]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'triggerEvent';

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
    var element = this;
    __webpack_require__.e/* import() */("plugin--trigger-event").then(__webpack_require__.bind(null, "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/jquery__trigger-event/plugin.js")).then(function () {
      (0, _jquery2.default)(element)[PLUGIN_NAME]();
    });
  });
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/lib/fn.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debounce = debounce;
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
        args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*
                                                                                                                                                                                                                                                                              jQuery plugin
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              ```
                                                                                                                                                                                                                                                                              import debug from 'debug';
                                                                                                                                                                                                                                                                              import plugin from '@fus078/plugins/lib';
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              const ELEMENT_SELECTOR = '[data-my-plugin]';
                                                                                                                                                                                                                                                                              const PLUGIN_NAME = 'MyPlugin';
                                                                                                                                                                                                                                                                              const MODULE_NAME = 'plugins/my-plugin';
                                                                                                                                                                                                                                                                              const log = debug(MODULE_NAME);
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              class PluginKlass {
                                                                                                                                                                                                                                                                                  constructor(element, options) {
                                                                                                                                                                                                                                                                                    log('new instance', element, options);
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                                    this.element = element;
                                                                                                                                                                                                                                                                                    this.options = options;
                                                                                                                                                                                                                                                                                    this.$element = $(element);
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                                    log('ready', this.$element);
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                                    this.init();
                                                                                                                                                                                                                                                                                  }
                                                                                                                                                                                                                                                                              }
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              PluginKlass.DEFAULTS = {
                                                                                                                                                                                                                                                                                someCamelCasedProperty: `${PLUGIN_NAME}:something`,
                                                                                                                                                                                                                                                                              };
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              plugin(PLUGIN_NAME, PluginKlass);
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              $(document).ready(() => {
                                                                                                                                                                                                                                                                                $(ELEMENT_SELECTOR)[PLUGIN_NAME]();
                                                                                                                                                                                                                                                                              });
                                                                                                                                                                                                                                                                              ```
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              Then using it in html:
                                                                                                                                                                                                                                                                              ```
                                                                                                                                                                                                                                                                              <div class="something-else"
                                                                                                                                                                                                                                                                                   data-my-plugin
                                                                                                                                                                                                                                                                                   data-my-plugin--some-camel-cased-property="a-string:something-else"></div>
                                                                                                                                                                                                                                                                              ```
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              Styelguide Core.Global.Javascript.JqueryPlugin
                                                                                                                                                                                                                                                                              */

// import * as events from './events';

exports.default = plugin;
exports.jquery = jquery;
exports.defaults = defaults;

var _jquery = __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _fn = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/lib/fn.js");

var fn = _interopRequireWildcard(_fn);

var _strings = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/lib/strings.js");

var strings = _interopRequireWildcard(_strings);

var _objects = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/lib/objects.js");

var objects = _interopRequireWildcard(_objects);

var _selectors = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/lib/selectors.js");

var selectors = _interopRequireWildcard(_selectors);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('core/plugins/lib');

function plugin(pluginName, klass) {
  var shortHand = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var formattedPluginName = (0, _strings.toCamelCase)(pluginName);
  var dataName = '__' + formattedPluginName;
  var old = _jquery2.default.fn[formattedPluginName];
  var ZERO = 0;

  klass.$bus = {
    subscribe: function subscribe(event, fn) {
      (0, _jquery2.default)(this).bind(event, fn);
    },
    publish: function publish(event, data) {
      (0, _jquery2.default)(this).trigger(event, [data]);
    }
  };

  klass.$util = {
    fn: fn,
    objects: objects,
    strings: strings,
    selectors: selectors
  };

  klass.prototype.selectors = selectors;
  klass.prototype.strings = strings;
  klass.prototype.objects = objects;
  klass.prototype.fn = fn;
  klass.prototype.inViewport = function (elm) {
    var rect = elm.getBoundingClientRect();
    var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
  };

  _jquery2.default.fn[pluginName] = function PluginFactory(option) {
    return this.each(function PluginInstanceFactory() {
      var $this = (0, _jquery2.default)(this);
      var data = $this.data();
      var overrides = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object' && option;
      var elementOptions = Object.keys(data).filter(function (key) {
        return (0, _strings.toCamelCase)(key).indexOf(formattedPluginName) >= ZERO;
      }).reduce(function (result, path) {
        var data = path && $this.data(path);
        var key = (0, _strings.toCamelCase)(path.replace(new RegExp(formattedPluginName + '-?'), ''));
        log(path, key, $this.data(path));

        if (key && data !== undefined) {
          result[key] = data;
        }
        return result;
      }, {});
      log(pluginName, { elementOptions: elementOptions });
      var instance = $this.data(dataName);
      var options = _jquery2.default.extend({}, klass.DEFAULTS, elementOptions, overrides);

      // store reference to instance
      if (!instance) {
        instance = new klass(this, options);
        instance.$utils = klass.$util;
        $this.data(dataName, instance);
        $this.addClass('u-' + pluginName);
      }

      // execute instance method
      if (typeof option === 'string') {
        instance[option]();
      }
    });
  };

  // - Short hand
  if (shortHand) {
    _jquery2.default[formattedPluginName] = function (options) {
      return (0, _jquery2.default)({})[formattedPluginName](options);
    };
  }

  // - No conflict
  // $.fn[formattedPluginName].noConflict = function noConflict () {
  //   $.fn[formattedPluginName] = old;
  // };
}

function jquery(name) {
  return function decorate(target) {
    plugin(name, target);
  };
}

function defaults(options) {
  return function decorate(target) {
    target.DEFAULTS = options;
  };
}

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/lib/objects.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.elementAttrtibutesToObject = elementAttrtibutesToObject;
exports.objectPath = objectPath;

var _debug = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _strings = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/lib/strings.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'app.core/lib/objects';
var log = (0, _debug2.default)(MODULE_NAME);

var ZERO = 0;

/**
 * Convert an elements attributes to an object, optionally filtering based on some predicate.
 * @param  {DOMElement}   element  [description]
 * @param  {Function} filterFn filtering function. return false to omit attribute.
 * @param  {Function} transformFn transform attribute name function. returns camelCase by default
 * @return {[type]}            [description]
 */
function elementAttrtibutesToObject(element) {
  var filterFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return true;
  };
  var transformFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (name) {
    return (0, _strings.toCamelCase)(name);
  };

  var output = {};
  var attrs = Array.from($(element).get(ZERO).attributes);

  if (!attrs) {
    return output;
  }

  log('converting element attributes to object', attrs);

  return attrs.reduce(function (result, attribute) {
    if (filterFn(attribute)) {
      var name = transformFn(attribute.name);
      var value = attribute.value;

      if (value === 'false' || value === 'true') {
        value = Boolean(value);
      }
      result[name] = attribute.value;
    }

    return result;
  }, output);
}

/**
 * Object.prop()
 *
 * Allows dot-notation access to object properties for both getting and setting.
 *
 * @param {Object} obj    The object we're getting from or setting
 * @param {string} prop   The dot-notated string defining the property location
 * @param {mixed}  val    For setting only; the value to set
 */

function objectPath(obj, path, val) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { delimiter: '.' };

  var props = path.split(options.delimiter);
  var final = props.pop();
  var part = void 0;

  for (var index = 0; index < props.length; index++) {
    part = props[index];
    if (typeof obj[part] === 'undefined') {
      // If we're setting
      if (typeof val !== 'undefined' && index != props.length) {
        // If we're not at the end of the props, keep adding new empty objects
        obj[part] = {};
      } else {
        return undefined;
      }
    }
    obj = obj[part];
  }
  return typeof val !== "undefined" ? obj[final] = val : obj[final];
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js")))

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/lib/selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SELECTOR_PATTERNS = undefined;
exports.selectorPattern = selectorPattern;
exports.selectTarget = selectTarget;

var _jquery = __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('fus078/plugins/lib/selectors');

function selectorPattern() {
  for (var _len = arguments.length, directives = Array(_len), _key = 0; _key < _len; _key++) {
    directives[_key] = arguments[_key];
  }

  return new RegExp('\\((' + directives.join('|') + ')(.*)\\)\\s?(.*)');
}

var SELECTOR_PATTERNS = exports.SELECTOR_PATTERNS = {

  // .find
  "children": selectorPattern('children'),

  // .closest
  "parent": selectorPattern('parent'),
  "from": selectorPattern('from'),
  "parents": selectorPattern('parents'),
  "siblings": selectorPattern('siblings'),
  "here": selectorPattern('here'),
  "self": selectorPattern('self')
};

function selectTarget(selector, $element) {
  var $target = void 0;

  var isClosestAncestoral = selector.match(SELECTOR_PATTERNS.parent);
  var isAllAncestoral = selector.match(SELECTOR_PATTERNS.parents);
  var isRetargeted = selector.match(SELECTOR_PATTERNS.from);
  var isAllDescendants = selector.match(SELECTOR_PATTERNS.children);
  var isGenerational = selector.match(SELECTOR_PATTERNS.here);
  var isSiblings = selector.match(SELECTOR_PATTERNS.siblings);
  var isSelfish = selector.match(SELECTOR_PATTERNS.self);

  // special retargeting root
  if (isRetargeted) {
    log('isRetargeted', isRetargeted[2], isRetargeted[3]);
    var $newElement = selectTarget(isRetargeted[2], $element);
    var newSelector = '(children) ' + isRetargeted[3];
    log('isRetargeted.newElement', $newElement);
    log('isRetargeted.newSelector', newSelector);
    $target = selectTarget(newSelector, $newElement);
    log('isRetargeted.target', $target);
  }

  // target is all ancestors
  else if (isAllAncestoral) {
      log('isAllAncestoral', isAllAncestoral);
      $target = $element.parents(isAllAncestoral[isAllAncestoral.length - 1]);
    }
    // target is closest ancestor
    else if (isClosestAncestoral) {
        log('isClosestAncestoral', isClosestAncestoral);
        $target = $element.closest(isClosestAncestoral[isClosestAncestoral.length - 1]);
      }
      // target is somewhere under current parent
      else if (isGenerational) {
          log('isGenerational', isGenerational);
          $target = $element.parent().find(isGenerational[isGenerational.length - 1]);
        }
        // target is only under self
        else if (isAllDescendants) {
            log('isAllDescendants', isAllDescendants);
            $target = $element.find(isAllDescendants[isAllDescendants.length - 1]);
          }
          // target is somewhere in siblings only
          else if (isSiblings) {
              log('isSiblings', isSiblings);
              $target = $element.siblings(isSiblings[isSiblings.length - 1]);
            }
            // target is source
            else if (!selector || isSelfish) {
                log('isSelfish', isSelfish);
                var selector = isSelfish[isSelfish.length - 1] || '*';
                $target = $element.filter(selector);
              }
              // target could be anywhere
              else {
                  log('global', selector);
                  $target = (0, _jquery2.default)(selector);
                }
  return $target;
}

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/plugins/lib/strings.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.toCamelCase = toCamelCase;
exports.tmpl = tmpl;
exports.$tmpl = $tmpl;
exports.mustache = mustache;
exports.booleanify = booleanify;

var _jquery = __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('core/jquery_plugin/strings');

function preserveCamelCase(str) {
  var isLastCharLower = false;
  var isLastCharUpper = false;
  var isLastLastCharUpper = false;

  for (var i = 0; i < str.length; i++) {
    var c = str[i];

    if (isLastCharLower && /[a-zA-Z]/.test(c) && c.toUpperCase() === c) {
      str = str.substr(0, i) + '-' + str.substr(i);
      isLastCharLower = false;
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = true;
      i++;
    } else if (isLastCharUpper && isLastLastCharUpper && /[a-zA-Z]/.test(c) && c.toLowerCase() === c) {
      str = str.substr(0, i - 1) + '-' + str.substr(i - 1);
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = false;
      isLastCharLower = true;
    } else {
      isLastCharLower = c.toLowerCase() === c;
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = c.toUpperCase() === c;
    }
  }

  return str;
}

function toCamelCase(str) {
  if (arguments.length > 1) {
    str = Array.from(arguments).map(function (x) {
      return x.trim();
    }).filter(function (x) {
      return x.length;
    }).join('-');
  } else {
    str = str.trim();
  }

  if (str.length === 0) {
    return '';
  }

  if (str.length === 1) {
    return str.toLowerCase();
  }

  if (/^[a-z0-9]+$/.test(str)) {
    return str;
  }

  var hasUpperCase = str !== str.toLowerCase();

  if (hasUpperCase) {
    str = preserveCamelCase(str);
  }

  return str.replace(/^[_.\- ]+/, '').toLowerCase().replace(/[_.\- ]+(\w|$)/g, function (m, p1) {
    return p1.toUpperCase();
  });
};

function tmpl(str, context) {
  var result = str;

  if (result) {

    Object.keys(context).forEach(function (item) {
      result = result.replace('{{' + item + '}}', context[item]);
    });
  }

  return result;
}

function $tmpl(element, context) {
  var $target = (0, _jquery2.default)(element);
  var templateString = $target.attr('data-text-template');
  var result = tmpl(templateString, context);

  $target.text(result);
}

/**
 * https://github.com/aishikaty/tiny-mustache
 * https://mustache.github.io/
 * @param  {String} template [description]
 * @param  {[type]} self     [description]
 * @param  {[type]} parent   [description]
 * @param  {[type]} invert   [description]
 * @return {[type]}          [description]
 */
function mustache(template, self, parent, invert) {
  var render = mustache;
  var output = "";
  var i;

  log('mustache', { template: template, self: self, parent: parent, invert: invert });

  function get(ctx, path) {
    path = path.pop ? path : path.split(".");
    ctx = ctx[path.shift()] || "";
    return 0 in path ? get(ctx, path) : ctx;
  }

  self = Array.isArray(self) ? self : self ? [self] : [];
  self = invert ? 0 in self ? [] : [1] : self;

  for (i = 0; i < self.length; i++) {
    var childCode = '';
    var depth = 0;
    var inverted;
    var ctx = _typeof(self[i]) == "object" ? self[i] : {};
    ctx = Object.assign({}, parent, ctx);
    ctx[""] = { "": self[i] };

    template.replace(/([\s\S]*?)({{((\/)|(\^)|#)(.*?)}}|$)/g, function (match, code, y, z, close, invert, name) {

      if (!depth) {
        output += code.replace(/{{{(.*?)}}}|{{(!?)(&?)(>?)(.*?)}}/g, function (match, raw, comment, isRaw, partial, name) {
          return raw ? get(ctx, raw) : isRaw ? get(ctx, name) : partial ? render(get(ctx, name), ctx) : !comment ? new Option(get(ctx, name)).innerHTML : "";
        });
        inverted = invert;
      } else {
        childCode += depth && !close || depth > 1 ? match : code;
      }

      if (close) {
        if (! --depth) {
          name = get(ctx, name);
          if (/^f/.test(typeof name === 'undefined' ? 'undefined' : _typeof(name))) {
            output += name.call(ctx, childCode, function (template) {
              return render(template, ctx);
            });
          } else {
            output += render(childCode, name, ctx, inverted);
          }
          childCode = "";
        }
      } else {
        ++depth;
      }
      log('mustache.output.' + depth, { output: output });
    });
  }
  log('mustache.output', { output: output });
  return output;
}

function booleanify(value) {
  var lower = value.toLowerCase();
  if (lower === 'false' || lower === '0') {
    return false;
  }
  return new Boolean(value);
}

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/polyfills/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var files = __webpack_require__("/opt/app/client/src/site__fus078/polyfills nonrecursive /.*\\.polyfill.js$/");
files.keys().forEach(files);

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/polyfills/svg.polyfill.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _debug = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('fus078/polyfills');

__webpack_require__.e/* import() */("vendor/svg4everybody@2.0.0").then(__webpack_require__.bind(null, "/opt/app/client/src/vendor/svg4everybody@2.0.0.js")).then(function (svg4everybody) {
	log('polyfilled.svg4everybody', svg4everybody);
	svg4everybody();
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/utilities/a11y__focus.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _focusSource = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/ally.js/src/style/focus-source.js");

var _focusSource2 = _interopRequireDefault(_focusSource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _focusSource2.default)();

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/utilities/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/utilities/a11y__focus.js");

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/vendor/foundation.init.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _debug = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('fus078/vendor/foundation');

__webpack_require__.e/* import() */("vendor/foundation@5.4.5").then(__webpack_require__.bind(null, "/opt/app/client/src/vendor/foundation@5.4.5.js")).then(function () {
	log('init');
	$(document).foundation({
		accordion: {
			//	callback used to animate open close
			//	TODO does not work properly with multi_expand: false
			//	to fix hook into toggled event on .accordion
			//	toggle contained .content divs using accordion settings
			multi_expand: true,
			callback: function callback(panel) {
				var isOpen = panel.hasClass('active');
				panel.slideToggle(isOpen);
			}
		}
	});
	log('init.done');
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js")))

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/vendor/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/vendor/foundation.init.js");

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/ally.js/src/event/shadow-focus.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _activeElements = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/ally.js/src/get/active-elements.js");

var _activeElements2 = _interopRequireDefault(_activeElements);

var _decorateService = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/ally.js/src/util/decorate-service.js");

var _decorateService2 = _interopRequireDefault(_decorateService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  Utility to observe focus changes within ShadowDOMs.

  USAGE:
    engage();
    document.body.addEventListener('shadow-focus', function(event) {
      // event.detail.elements: complete focus ancestry (array of nodes)
      // event.detail.active: the actually focused element within the ShadowDOM
      // event.detail.hosts: the shadow host ancestry of the active element
    }, false);

  Alternate implementation: https://github.com/cdata/focus-observer
*/

var engage = void 0;
var disengage = void 0;

if (typeof document === 'undefined' || !document.documentElement.createShadowRoot) {
  // no need to initialize any of this if we don't have ShadowDOM available
  engage = disengage = function disengage() {};
} else {
  var blurTimer = void 0;
  var blurElement = void 0;

  var handleElementBlurEvent = function handleElementBlurEvent() {
    stopHandleElementBlurEvent();
    // abort any handlers that come from document blur handler
    (window.clearImmediate || window.clearTimeout)(blurTimer);
    blurTimer = (window.setImmediate || window.setTimeout)(function () {
      handleFocusChange();
    });
  };

  var observeElementBlurEvent = function observeElementBlurEvent(element) {
    // call us when we're leaving the element
    element.addEventListener('blur', handleElementBlurEvent, true);
    blurElement = element;
  };

  var stopHandleElementBlurEvent = function stopHandleElementBlurEvent() {
    // once() - sometimes I miss jQuery's simplicity…
    blurElement && blurElement.removeEventListener('blur', handleElementBlurEvent, true);
    blurElement = null;
  };

  var handleFocusChange = function handleFocusChange() {
    var _active = (0, _activeElements2.default)();
    if (_active.length === 1) {
      stopHandleElementBlurEvent();
      return;
    }

    // listen for blur so we know when to re-validate
    observeElementBlurEvent(_active[0]);
    var shadowFocusEvent = new CustomEvent('shadow-focus', {
      bubbles: false,
      cancelable: false,
      detail: {
        // complete focus ancestry
        elements: _active,
        // the actually focused element
        active: _active[0],
        // shadow host ancestry
        hosts: _active.slice(1)
      }
    });

    document.dispatchEvent(shadowFocusEvent);
  };

  var handleDocumentFocusEvent = function handleDocumentFocusEvent() {
    (window.clearImmediate || window.clearTimeout)(blurTimer);
    handleFocusChange();
  };

  engage = function engage() {
    document.addEventListener('focus', handleDocumentFocusEvent, true);
  };

  disengage = function disengage() {
    (window.clearImmediate || window.clearTimeout)(blurTimer);
    blurElement && blurElement.removeEventListener('blur', handleElementBlurEvent, true);
    document.removeEventListener('focus', handleDocumentFocusEvent, true);
  };
}

exports.default = (0, _decorateService2.default)({ engage: engage, disengage: disengage });

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/ally.js/src/get/active-elements.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  if (document.activeElement === null) {
    // IE10 does not redirect focus to <body> when the activeElement is removed
    document.body.focus();
  }

  // Firefox currently leaks the shadowed element
  // @browser-issue Gecko https://bugzilla.mozilla.org/show_bug.cgi?id=1117535
  if ((0, _shadowed2.default)(document.activeElement)) {
    return walkFromShadowedElement();
  }

  return walkToShadowedElement();
};

var _shadowed = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/ally.js/src/is/shadowed.js");

var _shadowed2 = _interopRequireDefault(_shadowed);

var _shadowHostParents = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/ally.js/src/get/shadow-host-parents.js");

var _shadowHostParents2 = _interopRequireDefault(_shadowHostParents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// [0] always is the actual active element (even within web-components)
// [0+n] is the hierarchy of shadow-doms with [length -1] being the top most shadow-host

function walkToShadowedElement() {
  var list = [document.activeElement];

  while (list[0] && list[0].shadowRoot) {
    list.unshift(list[0].shadowRoot.activeElement);
  }

  return list;
}

function walkFromShadowedElement() {
  var hosts = (0, _shadowHostParents2.default)({ context: document.activeElement });
  return [document.activeElement].concat(hosts);
}

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/ally.js/src/get/shadow-host-parents.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref.context;

  var list = [];
  var element = (0, _contextToElement2.default)({
    label: 'get/shadow-host-parents',
    context: context
  });

  while (element) {
    element = (0, _shadowHost2.default)({ context: element });
    if (!element) {
      break;
    }

    list.push(element);
  }

  return list;
};

var _shadowHost = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/ally.js/src/get/shadow-host.js");

var _shadowHost2 = _interopRequireDefault(_shadowHost);

var _contextToElement = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/ally.js/src/util/context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/ally.js/src/get/shadow-host.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref.context;

  var element = (0, _contextToElement2.default)({
    label: 'get/shadow-host',
    context: context
  });

  // walk up to the root
  var container = null;

  while (element) {
    container = element;
    element = element.parentNode;
  }

  // https://developer.mozilla.org/en-US/docs/Web/API/Node.nodeType
  // NOTE: Firefox 34 does not expose ShadowRoot.host (but 37 does)
  if (container.nodeType === container.DOCUMENT_FRAGMENT_NODE && container.host) {
    // the root is attached to a fragment node that has a host
    return container.host;
  }

  return null;
};

var _contextToElement = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/ally.js/src/util/context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/ally.js/src/is/shadowed.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (context) {
  var element = (0, _contextToElement2.default)({
    label: 'is/shadowed',
    resolveDocument: true,
    context: context
  });

  return Boolean((0, _shadowHost2.default)({ context: element }));
};

var _contextToElement = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/ally.js/src/util/context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

var _shadowHost = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/ally.js/src/get/shadow-host.js");

var _shadowHost2 = _interopRequireDefault(_shadowHost);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/ally.js/src/observe/interaction-type.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decorateService = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/ally.js/src/util/decorate-service.js");

var _decorateService2 = _interopRequireDefault(_decorateService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// counters to track primary input
var _activePointers = 0;
/*
  Observe keyboard-, pointer-, mouse- and touch-events so that a query for
  the current interaction type can be made at any time. For pointer interaction
  this observer is limited to pointer button down/up - move is not observed!

  USAGE:
    var listener = engage();
    listener.get() === {pointer: Boolean, key: Boolean}
*/

var _activeKeys = 0;

var pointerStartEvents = ['touchstart', 'pointerdown', 'MSPointerDown', 'mousedown'];
var pointerEndEvents = ['touchend', 'touchcancel', 'pointerup', 'MSPointerUp', 'pointercancel', 'MSPointerCancel', 'mouseup'];

function handleWindowBlurEvent() {
  // reset internal counters when window loses focus
  _activePointers = 0;
  _activeKeys = 0;
}

function handlePointerStartEvent(event) {
  if (event.isPrimary === false) {
    // ignore non-primary pointer events
    // https://w3c.github.io/pointerevents/#widl-PointerEvent-isPrimary
    return;
  }

  // mousedown without following mouseup
  // (likely not possible in Chrome)
  _activePointers++;
}

function handlePointerEndEvent(event) {
  if (event.isPrimary === false) {
    // ignore non-primary pointer events
    // https://w3c.github.io/pointerevents/#widl-PointerEvent-isPrimary
    return;
  } else if (event.touches) {
    _activePointers = event.touches.length;
    return;
  }

  // delay reset to when the current handlers are executed
  (window.setImmediate || window.setTimeout)(function () {
    // mouseup without prior mousedown
    // (drag something out of the window)
    _activePointers = Math.max(_activePointers - 1, 0);
  });
}

function handleKeyStartEvent(event) {
  // ignore modifier keys
  switch (event.keyCode || event.which) {
    case 16: // space
    case 17: // control
    case 18: // alt
    case 91: // command left
    case 93:
      // command right
      return;
  }

  // keydown without a following keyup
  // (may happen on CMD+TAB)
  _activeKeys++;
}

function handleKeyEndEvent(event) {
  // ignore modifier keys
  switch (event.keyCode || event.which) {
    case 16: // space
    case 17: // control
    case 18: // alt
    case 91: // command left
    case 93:
      // command right
      return;
  }

  // delay reset to when the current handlers are executed
  (window.setImmediate || window.setTimeout)(function () {
    // keyup without prior keydown
    // (may happen on CMD+R)
    _activeKeys = Math.max(_activeKeys - 1, 0);
  });
}

function getInteractionType() {
  return {
    pointer: Boolean(_activePointers),
    key: Boolean(_activeKeys)
  };
}

function disengage() {
  _activePointers = _activeKeys = 0;
  window.removeEventListener('blur', handleWindowBlurEvent, false);
  document.documentElement.removeEventListener('keydown', handleKeyStartEvent, true);
  document.documentElement.removeEventListener('keyup', handleKeyEndEvent, true);
  pointerStartEvents.forEach(function (event) {
    document.documentElement.removeEventListener(event, handlePointerStartEvent, true);
  });
  pointerEndEvents.forEach(function (event) {
    document.documentElement.removeEventListener(event, handlePointerEndEvent, true);
  });
}

function engage() {
  // window blur must be in bubble phase so it won't capture regular blurs
  window.addEventListener('blur', handleWindowBlurEvent, false);
  // handlers to identify the method of focus change
  document.documentElement.addEventListener('keydown', handleKeyStartEvent, true);
  document.documentElement.addEventListener('keyup', handleKeyEndEvent, true);
  pointerStartEvents.forEach(function (event) {
    document.documentElement.addEventListener(event, handlePointerStartEvent, true);
  });
  pointerEndEvents.forEach(function (event) {
    document.documentElement.addEventListener(event, handlePointerEndEvent, true);
  });

  return {
    get: getInteractionType
  };
}

exports.default = (0, _decorateService2.default)({ engage: engage, disengage: disengage });

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/ally.js/src/style/focus-source.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toggleClass = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/ally.js/src/util/toggle-class.js");

var _shadowFocus = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/ally.js/src/event/shadow-focus.js");

var _shadowFocus2 = _interopRequireDefault(_shadowFocus);

var _interactionType = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/ally.js/src/observe/interaction-type.js");

var _interactionType2 = _interopRequireDefault(_interactionType);

var _decorateService = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/ally.js/src/util/decorate-service.js");

var _decorateService2 = _interopRequireDefault(_decorateService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// preferring focusin/out because they are synchronous in IE10+11

/*
  add data-focus-source attribute to html element containing "key", "pointer" or "script"
  depending on the input method used to change focus.

  USAGE:
    style/focus-source()

    body :focus {
      outline: 1px solid grey;
    }

    html[data-focus-source="key"] body :focus {
      outline: 5px solid red;
    }

    html[data-focus-source="key"] body :focus {
      outline: 1px solid blue;
    }

  NOTE: I don't have a GamePad to test, if you do and you want to
  implement an observer for https://w3c.github.io/gamepad/ - send a PR!

  Alternate implementation: https://github.com/alice/modality
*/

var supportsFocusIn = typeof document !== 'undefined' && 'onfocusin' in document;
var focusEventName = supportsFocusIn ? 'focusin' : 'focus';
var blurEventName = supportsFocusIn ? 'focusout' : 'blur';

// interface to read interaction-type-listener state
var interactionTypeHandler = void 0;
var shadowHandle = void 0;
// keep track of last focus source
var current = null;
// overwrite focus source for use with the every upcoming focus event
var lock = null;
// keep track of ever having used a particular input method to change focus
var used = {
  pointer: false,
  key: false,
  script: false,
  initial: false
};

function handleFocusEvent(event) {
  var source = '';
  if (event.type === focusEventName || event.type === 'shadow-focus') {
    var interactionType = interactionTypeHandler.get();
    source = lock || interactionType.pointer && 'pointer' || interactionType.key && 'key' || 'script';
  } else if (event.type === 'initial') {
    source = 'initial';
  }

  document.documentElement.setAttribute('data-focus-source', source);

  if (event.type !== blurEventName) {
    if (!used[source]) {
      (0, _toggleClass.addClass)(document.documentElement, 'focus-source-' + source);
    }

    used[source] = true;
    current = source;
  }
}

function getCurrentFocusSource() {
  return current;
}

function getUsedFocusSource(source) {
  return used[source];
}

function lockFocusSource(source) {
  lock = source;
}

function unlockFocusSource() {
  lock = false;
}

function disengage() {
  // clear dom state
  handleFocusEvent({ type: blurEventName });
  current = lock = null;
  Object.keys(used).forEach(function (key) {
    (0, _toggleClass.removeClass)(document.documentElement, 'focus-source-' + key);
    used[key] = false;
  });
  // kill interaction type identification listener
  interactionTypeHandler.disengage();
  // kill shadow-focus event dispatcher
  shadowHandle && shadowHandle.disengage();
  document.removeEventListener('shadow-focus', handleFocusEvent, true);
  document.documentElement.removeEventListener(focusEventName, handleFocusEvent, true);
  document.documentElement.removeEventListener(blurEventName, handleFocusEvent, true);
  document.documentElement.removeAttribute('data-focus-source');
}

function engage() {
  // enable the shadow-focus event dispatcher
  shadowHandle = (0, _shadowFocus2.default)();
  // handlers to modify the focused element
  document.addEventListener('shadow-focus', handleFocusEvent, true);
  document.documentElement.addEventListener(focusEventName, handleFocusEvent, true);
  document.documentElement.addEventListener(blurEventName, handleFocusEvent, true);
  // enable the interaction type identification observer
  interactionTypeHandler = (0, _interactionType2.default)();
  // set up initial dom state
  handleFocusEvent({ type: 'initial' });

  return {
    used: getUsedFocusSource,
    current: getCurrentFocusSource,
    lock: lockFocusSource,
    unlock: unlockFocusSource
  };
}

exports.default = (0, _decorateService2.default)({ engage: engage, disengage: disengage });

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/ally.js/src/util/context-to-element.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (_ref) {
  var context = _ref.context,
      _ref$label = _ref.label,
      label = _ref$label === undefined ? 'context-to-element' : _ref$label,
      resolveDocument = _ref.resolveDocument,
      defaultToDocument = _ref.defaultToDocument;

  var element = (0, _nodeArray2.default)(context)[0];

  if (resolveDocument && element && element.nodeType === Node.DOCUMENT_NODE) {
    element = element.documentElement;
  }

  if (!element && defaultToDocument) {
    return document.documentElement;
  }

  if (!element) {
    throw new TypeError(label + ' requires valid options.context');
  }

  if (element.nodeType !== Node.ELEMENT_NODE && element.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) {
    throw new TypeError(label + ' requires options.context to be an Element');
  }

  return element;
};

var _nodeArray = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/ally.js/src/util/node-array.js");

var _nodeArray2 = _interopRequireDefault(_nodeArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/ally.js/src/util/decorate-service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      engage = _ref2.engage,
      disengage = _ref2.disengage;

  var data = {
    engage: engage || noop,
    disengage: disengage || noop,
    instances: 0,
    _result: null
  };

  return initialize.bind(data);
};

/*
  The Singleton Decorator is intended to allow modules to initialize a ("singleton") component as if
  it was the only one using it. Every module gets to initialize and destruct the component by itself.
  Via simple reference counting the component keeps track of how many modules have initialized it,
  so it destructs only when the last module is gone. This decorator hides the component's singleton
  nature from the application in order to offer a homogenous API.

  engage() can return an object (result) with methods to expose to the consumer,
  upon initialization result.disengage is added and returned to the consumer.
*/

function destruct() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      force = _ref.force;

  if (force) {
    this.instances = 0;
  } else {
    this.instances--;
  }

  if (!this.instances) {
    this.disengage();
    this._result = null;
  }
}

function initialize() {
  if (this.instances) {
    this.instances++;
    return this._result;
  }

  this.instances++;
  this._result = this.engage() || {};
  this._result.disengage = destruct.bind(this);

  return this._result;
}

function noop() {}

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/ally.js/src/util/node-array.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (input) {
  if (!input) {
    return [];
  }

  if (Array.isArray(input)) {
    return input;
  }

  // instanceof Node - does not work with iframes
  if (input.nodeType !== undefined) {
    return [input];
  }

  if (typeof input === 'string') {
    input = document.querySelectorAll(input);
  }

  if (input.length !== undefined) {
    return [].slice.call(input, 0);
  }

  throw new TypeError('unexpected input ' + String(input));
};

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/ally.js/src/util/toggle-class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleClass = toggleClass;
exports.removeClass = removeClass;
exports.addClass = addClass;
//
// This util allows to easily add, remove or toggle classes.
//
// Using it is neccessary as IE 9 doesn't support element classList
// and IE 11 doesn't support classList for SVG elements
// see also https://developer.mozilla.org/en/docs/Web/API/Element/classList
//
// This file is a replacement for domtokenlist because of
// https://github.com/medialize/ally.js/issues/147
//
// Usage:
//
// toggleClass(div, 'demo'); // Toggles the class `demo`
// toggleClass(div, 'demo', true); // Adds the class `demo`
// toggleClass(div, 'demo', false); // removes the class `demo`
//
// removeClass(div, 'demo');
// addClass(div, 'demo');
//

/**
 * Extract an array of all classNames of the given DOM or SVG node
 */
function getClassNames(element) {
  var className = element.getAttribute && element.getAttribute('class') || '';
  return className === '' ? [] : className.split(' ');
}

function toggleClass(element, className, force) {
  var classNames = getClassNames(element);
  var idx = classNames.indexOf(className);
  var hasClass = idx !== -1;
  var shouldHaveClass = force !== undefined ? force : !hasClass;
  // Break if classes are already set/removed
  if (shouldHaveClass === hasClass) {
    return;
  }
  // Remove class
  if (!shouldHaveClass) {
    classNames.splice(idx, 1);
  }
  // Add class
  if (shouldHaveClass) {
    classNames.push(className);
  }
  element.setAttribute('class', classNames.join(' '));
}

function removeClass(element, className) {
  return toggleClass(element, className, false);
}

function addClass(element, className) {
  return toggleClass(element, className, true);
}

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/desandro-matches-selector/matches-selector.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * matchesSelector v2.0.2
 * matchesSelector( element, '.selector' )
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */

(function (window, factory) {
  /*global define: false, module: false */
  'use strict';
  // universal module definition

  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.matchesSelector = factory();
  }
})(window, function factory() {
  'use strict';

  var matchesMethod = function () {
    var ElemProto = window.Element.prototype;
    // check for the standard method name first
    if (ElemProto.matches) {
      return 'matches';
    }
    // check un-prefixed
    if (ElemProto.matchesSelector) {
      return 'matchesSelector';
    }
    // check vendor prefixes
    var prefixes = ['webkit', 'moz', 'ms', 'o'];

    for (var i = 0; i < prefixes.length; i++) {
      var prefix = prefixes[i];
      var method = prefix + 'MatchesSelector';
      if (ElemProto[method]) {
        return method;
      }
    }
  }();

  return function matchesSelector(elem, selector) {
    return elem[matchesMethod](selector);
  };
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/ev-emitter/ev-emitter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */

/* jshint unused: true, undef: true, strict: true */

(function (global, factory) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, window */
  if (true) {
    // AMD - RequireJS
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
    // CommonJS - Browserify, Webpack
    module.exports = factory();
  } else {
    // Browser globals
    global.EvEmitter = factory();
  }
})(typeof window != 'undefined' ? window : undefined, function () {

  "use strict";

  function EvEmitter() {}

  var proto = EvEmitter.prototype;

  proto.on = function (eventName, listener) {
    if (!eventName || !listener) {
      return;
    }
    // set events hash
    var events = this._events = this._events || {};
    // set listeners array
    var listeners = events[eventName] = events[eventName] || [];
    // only add once
    if (listeners.indexOf(listener) == -1) {
      listeners.push(listener);
    }

    return this;
  };

  proto.once = function (eventName, listener) {
    if (!eventName || !listener) {
      return;
    }
    // add event
    this.on(eventName, listener);
    // set once flag
    // set onceEvents hash
    var onceEvents = this._onceEvents = this._onceEvents || {};
    // set onceListeners object
    var onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
    // set flag
    onceListeners[listener] = true;

    return this;
  };

  proto.off = function (eventName, listener) {
    var listeners = this._events && this._events[eventName];
    if (!listeners || !listeners.length) {
      return;
    }
    var index = listeners.indexOf(listener);
    if (index != -1) {
      listeners.splice(index, 1);
    }

    return this;
  };

  proto.emitEvent = function (eventName, args) {
    var listeners = this._events && this._events[eventName];
    if (!listeners || !listeners.length) {
      return;
    }
    // copy over to avoid interference if .off() in listener
    listeners = listeners.slice(0);
    args = args || [];
    // once stuff
    var onceListeners = this._onceEvents && this._onceEvents[eventName];

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      var isOnce = onceListeners && onceListeners[listener];
      if (isOnce) {
        // remove listener
        // remove before trigger to prevent recursion
        this.off(eventName, listener);
        // unset once flag
        delete onceListeners[listener];
      }
      // trigger listener
      listener.apply(this, args);
    }

    return this;
  };

  proto.allOff = function () {
    delete this._events;
    delete this._onceEvents;
  };

  return EvEmitter;
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/fizzy-ui-utils/utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Fizzy UI utils v2.0.7
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

(function (window, factory) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */

  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/desandro-matches-selector/matches-selector.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (matchesSelector) {
      return factory(window, matchesSelector);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, require('desandro-matches-selector'));
  } else {
    // browser global
    window.fizzyUIUtils = factory(window, window.matchesSelector);
  }
})(window, function factory(window, matchesSelector) {

  'use strict';

  var utils = {};

  // ----- extend ----- //

  // extends objects
  utils.extend = function (a, b) {
    for (var prop in b) {
      a[prop] = b[prop];
    }
    return a;
  };

  // ----- modulo ----- //

  utils.modulo = function (num, div) {
    return (num % div + div) % div;
  };

  // ----- makeArray ----- //

  var arraySlice = Array.prototype.slice;

  // turn element or nodeList into an array
  utils.makeArray = function (obj) {
    if (Array.isArray(obj)) {
      // use object if already an array
      return obj;
    }
    // return empty array if undefined or null. #6
    if (obj === null || obj === undefined) {
      return [];
    }

    var isArrayLike = (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) == 'object' && typeof obj.length == 'number';
    if (isArrayLike) {
      // convert nodeList to array
      return arraySlice.call(obj);
    }

    // array of single index
    return [obj];
  };

  // ----- removeFrom ----- //

  utils.removeFrom = function (ary, obj) {
    var index = ary.indexOf(obj);
    if (index != -1) {
      ary.splice(index, 1);
    }
  };

  // ----- getParent ----- //

  utils.getParent = function (elem, selector) {
    while (elem.parentNode && elem != document.body) {
      elem = elem.parentNode;
      if (matchesSelector(elem, selector)) {
        return elem;
      }
    }
  };

  // ----- getQueryElement ----- //

  // use element as selector string
  utils.getQueryElement = function (elem) {
    if (typeof elem == 'string') {
      return document.querySelector(elem);
    }
    return elem;
  };

  // ----- handleEvent ----- //

  // enable .ontype to trigger from .addEventListener( elem, 'type' )
  utils.handleEvent = function (event) {
    var method = 'on' + event.type;
    if (this[method]) {
      this[method](event);
    }
  };

  // ----- filterFindElements ----- //

  utils.filterFindElements = function (elems, selector) {
    // make array of elems
    elems = utils.makeArray(elems);
    var ffElems = [];

    elems.forEach(function (elem) {
      // check that elem is an actual element
      if (!(elem instanceof HTMLElement)) {
        return;
      }
      // add elem if no selector
      if (!selector) {
        ffElems.push(elem);
        return;
      }
      // filter & find items if we have a selector
      // filter
      if (matchesSelector(elem, selector)) {
        ffElems.push(elem);
      }
      // find children
      var childElems = elem.querySelectorAll(selector);
      // concat childElems to filterFound array
      for (var i = 0; i < childElems.length; i++) {
        ffElems.push(childElems[i]);
      }
    });

    return ffElems;
  };

  // ----- debounceMethod ----- //

  utils.debounceMethod = function (_class, methodName, threshold) {
    threshold = threshold || 100;
    // original method
    var method = _class.prototype[methodName];
    var timeoutName = methodName + 'Timeout';

    _class.prototype[methodName] = function () {
      var timeout = this[timeoutName];
      clearTimeout(timeout);

      var args = arguments;
      var _this = this;
      this[timeoutName] = setTimeout(function () {
        method.apply(_this, args);
        delete _this[timeoutName];
      }, threshold);
    };
  };

  // ----- docReady ----- //

  utils.docReady = function (callback) {
    var readyState = document.readyState;
    if (readyState == 'complete' || readyState == 'interactive') {
      // do async to allow for other scripts to run. metafizzy/flickity#441
      setTimeout(callback);
    } else {
      document.addEventListener('DOMContentLoaded', callback);
    }
  };

  // ----- htmlInit ----- //

  // http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
  utils.toDashed = function (str) {
    return str.replace(/(.)([A-Z])/g, function (match, $1, $2) {
      return $1 + '-' + $2;
    }).toLowerCase();
  };

  var console = window.console;
  /**
   * allow user to initialize classes via [data-namespace] or .js-namespace class
   * htmlInit( Widget, 'widgetName' )
   * options are parsed from data-namespace-options
   */
  utils.htmlInit = function (WidgetClass, namespace) {
    utils.docReady(function () {
      var dashedNamespace = utils.toDashed(namespace);
      var dataAttr = 'data-' + dashedNamespace;
      var dataAttrElems = document.querySelectorAll('[' + dataAttr + ']');
      var jsDashElems = document.querySelectorAll('.js-' + dashedNamespace);
      var elems = utils.makeArray(dataAttrElems).concat(utils.makeArray(jsDashElems));
      var dataOptionsAttr = dataAttr + '-options';
      var jQuery = window.jQuery;

      elems.forEach(function (elem) {
        var attr = elem.getAttribute(dataAttr) || elem.getAttribute(dataOptionsAttr);
        var options;
        try {
          options = attr && JSON.parse(attr);
        } catch (error) {
          // log error, do not initialize
          if (console) {
            console.error('Error parsing ' + dataAttr + ' on ' + elem.className + ': ' + error);
          }
          return;
        }
        // initialize
        var instance = new WidgetClass(elem, options);
        // make available via $().data('namespace')
        if (jQuery) {
          jQuery.data(elem, namespace, instance);
        }
      });
    });
  };

  // -----  ----- //

  return utils;
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/flickity/js/add-remove-cell.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// add, remove cell
(function (window, factory) {
  // universal module definition
  /* jshint strict: false */
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/flickity/js/flickity.js"), __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/fizzy-ui-utils/utils.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (Flickity, utils) {
      return factory(window, Flickity, utils);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, require('./flickity'), require('fizzy-ui-utils'));
  } else {
    // browser global
    factory(window, window.Flickity, window.fizzyUIUtils);
  }
})(window, function factory(window, Flickity, utils) {

  'use strict';

  // append cells to a document fragment

  function getCellsFragment(cells) {
    var fragment = document.createDocumentFragment();
    cells.forEach(function (cell) {
      fragment.appendChild(cell.element);
    });
    return fragment;
  }

  // -------------------------- add/remove cell prototype -------------------------- //

  var proto = Flickity.prototype;

  /**
   * Insert, prepend, or append cells
   * @param {Element, Array, NodeList} elems
   * @param {Integer} index
   */
  proto.insert = function (elems, index) {
    var cells = this._makeCells(elems);
    if (!cells || !cells.length) {
      return;
    }
    var len = this.cells.length;
    // default to append
    index = index === undefined ? len : index;
    // add cells with document fragment
    var fragment = getCellsFragment(cells);
    // append to slider
    var isAppend = index == len;
    if (isAppend) {
      this.slider.appendChild(fragment);
    } else {
      var insertCellElement = this.cells[index].element;
      this.slider.insertBefore(fragment, insertCellElement);
    }
    // add to this.cells
    if (index === 0) {
      // prepend, add to start
      this.cells = cells.concat(this.cells);
    } else if (isAppend) {
      // append, add to end
      this.cells = this.cells.concat(cells);
    } else {
      // insert in this.cells
      var endCells = this.cells.splice(index, len - index);
      this.cells = this.cells.concat(cells).concat(endCells);
    }

    this._sizeCells(cells);
    this.cellChange(index, true);
  };

  proto.append = function (elems) {
    this.insert(elems, this.cells.length);
  };

  proto.prepend = function (elems) {
    this.insert(elems, 0);
  };

  /**
   * Remove cells
   * @param {Element, Array, NodeList} elems
   */
  proto.remove = function (elems) {
    var cells = this.getCells(elems);
    if (!cells || !cells.length) {
      return;
    }

    var minCellIndex = this.cells.length - 1;
    // remove cells from collection & DOM
    cells.forEach(function (cell) {
      cell.remove();
      var index = this.cells.indexOf(cell);
      minCellIndex = Math.min(index, minCellIndex);
      utils.removeFrom(this.cells, cell);
    }, this);

    this.cellChange(minCellIndex, true);
  };

  /**
   * logic to be run after a cell's size changes
   * @param {Element} elem - cell's element
   */
  proto.cellSizeChange = function (elem) {
    var cell = this.getCell(elem);
    if (!cell) {
      return;
    }
    cell.getSize();

    var index = this.cells.indexOf(cell);
    this.cellChange(index);
  };

  /**
   * logic any time a cell is changed: added, removed, or size changed
   * @param {Integer} changedCellIndex - index of the changed cell, optional
   */
  proto.cellChange = function (changedCellIndex, isPositioningSlider) {
    var prevSelectedElem = this.selectedElement;
    this._positionCells(changedCellIndex);
    this._getWrapShiftCells();
    this.setGallerySize();
    // update selectedIndex
    // try to maintain position & select previous selected element
    var cell = this.getCell(prevSelectedElem);
    if (cell) {
      this.selectedIndex = this.getCellSlideIndex(cell);
    }
    this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex);

    this.emitEvent('cellChange', [changedCellIndex]);
    // position slider
    this.select(this.selectedIndex);
    // do not position slider after lazy load
    if (isPositioningSlider) {
      this.positionSliderAtSelected();
    }
  };

  // -----  ----- //

  return Flickity;
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/flickity/js/animate.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// animate
(function (window, factory) {
  // universal module definition
  /* jshint strict: false */
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/fizzy-ui-utils/utils.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (utils) {
      return factory(window, utils);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, require('fizzy-ui-utils'));
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.animatePrototype = factory(window, window.fizzyUIUtils);
  }
})(window, function factory(window, utils) {

  'use strict';

  // -------------------------- animate -------------------------- //

  var proto = {};

  proto.startAnimation = function () {
    if (this.isAnimating) {
      return;
    }

    this.isAnimating = true;
    this.restingFrames = 0;
    this.animate();
  };

  proto.animate = function () {
    this.applyDragForce();
    this.applySelectedAttraction();

    var previousX = this.x;

    this.integratePhysics();
    this.positionSlider();
    this.settle(previousX);
    // animate next frame
    if (this.isAnimating) {
      var _this = this;
      requestAnimationFrame(function animateFrame() {
        _this.animate();
      });
    }
  };

  proto.positionSlider = function () {
    var x = this.x;
    // wrap position around
    if (this.options.wrapAround && this.cells.length > 1) {
      x = utils.modulo(x, this.slideableWidth);
      x = x - this.slideableWidth;
      this.shiftWrapCells(x);
    }

    this.setTranslateX(x, this.isAnimating);
    this.dispatchScrollEvent();
  };

  proto.setTranslateX = function (x, is3d) {
    x += this.cursorPosition;
    // reverse if right-to-left and using transform
    x = this.options.rightToLeft ? -x : x;
    var translateX = this.getPositionValue(x);
    // use 3D tranforms for hardware acceleration on iOS
    // but use 2D when settled, for better font-rendering
    this.slider.style.transform = is3d ? 'translate3d(' + translateX + ',0,0)' : 'translateX(' + translateX + ')';
  };

  proto.dispatchScrollEvent = function () {
    var firstSlide = this.slides[0];
    if (!firstSlide) {
      return;
    }
    var positionX = -this.x - firstSlide.target;
    var progress = positionX / this.slidesWidth;
    this.dispatchEvent('scroll', null, [progress, positionX]);
  };

  proto.positionSliderAtSelected = function () {
    if (!this.cells.length) {
      return;
    }
    this.x = -this.selectedSlide.target;
    this.velocity = 0; // stop wobble
    this.positionSlider();
  };

  proto.getPositionValue = function (position) {
    if (this.options.percentPosition) {
      // percent position, round to 2 digits, like 12.34%
      return Math.round(position / this.size.innerWidth * 10000) * 0.01 + '%';
    } else {
      // pixel positioning
      return Math.round(position) + 'px';
    }
  };

  proto.settle = function (previousX) {
    // keep track of frames where x hasn't moved
    if (!this.isPointerDown && Math.round(this.x * 100) == Math.round(previousX * 100)) {
      this.restingFrames++;
    }
    // stop animating if resting for 3 or more frames
    if (this.restingFrames > 2) {
      this.isAnimating = false;
      delete this.isFreeScrolling;
      // render position with translateX when settled
      this.positionSlider();
      this.dispatchEvent('settle', null, [this.selectedIndex]);
    }
  };

  proto.shiftWrapCells = function (x) {
    // shift before cells
    var beforeGap = this.cursorPosition + x;
    this._shiftCells(this.beforeShiftCells, beforeGap, -1);
    // shift after cells
    var afterGap = this.size.innerWidth - (x + this.slideableWidth + this.cursorPosition);
    this._shiftCells(this.afterShiftCells, afterGap, 1);
  };

  proto._shiftCells = function (cells, gap, shift) {
    for (var i = 0; i < cells.length; i++) {
      var cell = cells[i];
      var cellShift = gap > 0 ? shift : 0;
      cell.wrapShift(cellShift);
      gap -= cell.size.outerWidth;
    }
  };

  proto._unshiftCells = function (cells) {
    if (!cells || !cells.length) {
      return;
    }
    for (var i = 0; i < cells.length; i++) {
      cells[i].wrapShift(0);
    }
  };

  // -------------------------- physics -------------------------- //

  proto.integratePhysics = function () {
    this.x += this.velocity;
    this.velocity *= this.getFrictionFactor();
  };

  proto.applyForce = function (force) {
    this.velocity += force;
  };

  proto.getFrictionFactor = function () {
    return 1 - this.options[this.isFreeScrolling ? 'freeScrollFriction' : 'friction'];
  };

  proto.getRestingPosition = function () {
    // my thanks to Steven Wittens, who simplified this math greatly
    return this.x + this.velocity / (1 - this.getFrictionFactor());
  };

  proto.applyDragForce = function () {
    if (!this.isDraggable || !this.isPointerDown) {
      return;
    }
    // change the position to drag position by applying force
    var dragVelocity = this.dragX - this.x;
    var dragForce = dragVelocity - this.velocity;
    this.applyForce(dragForce);
  };

  proto.applySelectedAttraction = function () {
    // do not attract if pointer down or no slides
    var dragDown = this.isDraggable && this.isPointerDown;
    if (dragDown || this.isFreeScrolling || !this.slides.length) {
      return;
    }
    var distance = this.selectedSlide.target * -1 - this.x;
    var force = distance * this.options.selectedAttraction;
    this.applyForce(force);
  };

  return proto;
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/flickity/js/cell.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// Flickity.Cell
(function (window, factory) {
  // universal module definition
  /* jshint strict: false */
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/get-size/get-size.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (getSize) {
      return factory(window, getSize);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, require('get-size'));
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.Cell = factory(window, window.getSize);
  }
})(window, function factory(window, getSize) {

  'use strict';

  function Cell(elem, parent) {
    this.element = elem;
    this.parent = parent;

    this.create();
  }

  var proto = Cell.prototype;

  proto.create = function () {
    this.element.style.position = 'absolute';
    this.element.setAttribute('aria-hidden', 'true');
    this.x = 0;
    this.shift = 0;
  };

  proto.destroy = function () {
    // reset style
    this.unselect();
    this.element.style.position = '';
    var side = this.parent.originSide;
    this.element.style[side] = '';
  };

  proto.getSize = function () {
    this.size = getSize(this.element);
  };

  proto.setPosition = function (x) {
    this.x = x;
    this.updateTarget();
    this.renderPosition(x);
  };

  // setDefaultTarget v1 method, backwards compatibility, remove in v3
  proto.updateTarget = proto.setDefaultTarget = function () {
    var marginProperty = this.parent.originSide == 'left' ? 'marginLeft' : 'marginRight';
    this.target = this.x + this.size[marginProperty] + this.size.width * this.parent.cellAlign;
  };

  proto.renderPosition = function (x) {
    // render position of cell with in slider
    var side = this.parent.originSide;
    this.element.style[side] = this.parent.getPositionValue(x);
  };

  proto.select = function () {
    this.element.classList.add('is-selected');
    this.element.removeAttribute('aria-hidden');
  };

  proto.unselect = function () {
    this.element.classList.remove('is-selected');
    this.element.setAttribute('aria-hidden', 'true');
  };

  /**
   * @param {Integer} factor - 0, 1, or -1
  **/
  proto.wrapShift = function (shift) {
    this.shift = shift;
    this.renderPosition(this.x + this.parent.slideableWidth * shift);
  };

  proto.remove = function () {
    this.element.parentNode.removeChild(this.element);
  };

  return Cell;
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/flickity/js/drag.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// drag
(function (window, factory) {
  // universal module definition
  /* jshint strict: false */
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/flickity/js/flickity.js"), __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/unidragger/unidragger.js"), __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/fizzy-ui-utils/utils.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (Flickity, Unidragger, utils) {
      return factory(window, Flickity, Unidragger, utils);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, require('./flickity'), require('unidragger'), require('fizzy-ui-utils'));
  } else {
    // browser global
    window.Flickity = factory(window, window.Flickity, window.Unidragger, window.fizzyUIUtils);
  }
})(window, function factory(window, Flickity, Unidragger, utils) {

  'use strict';

  // ----- defaults ----- //

  utils.extend(Flickity.defaults, {
    draggable: '>1',
    dragThreshold: 3
  });

  // ----- create ----- //

  Flickity.createMethods.push('_createDrag');

  // -------------------------- drag prototype -------------------------- //

  var proto = Flickity.prototype;
  utils.extend(proto, Unidragger.prototype);
  proto._touchActionValue = 'pan-y';

  // --------------------------  -------------------------- //

  var isTouch = 'createTouch' in document;
  var isTouchmoveScrollCanceled = false;

  proto._createDrag = function () {
    this.on('activate', this.onActivateDrag);
    this.on('uiChange', this._uiChangeDrag);
    this.on('deactivate', this.onDeactivateDrag);
    this.on('cellChange', this.updateDraggable);
    // TODO updateDraggable on resize? if groupCells & slides change
    // HACK - add seemingly innocuous handler to fix iOS 10 scroll behavior
    // #457, RubaXa/Sortable#973
    if (isTouch && !isTouchmoveScrollCanceled) {
      window.addEventListener('touchmove', function () {});
      isTouchmoveScrollCanceled = true;
    }
  };

  proto.onActivateDrag = function () {
    this.handles = [this.viewport];
    this.bindHandles();
    this.updateDraggable();
  };

  proto.onDeactivateDrag = function () {
    this.unbindHandles();
    this.element.classList.remove('is-draggable');
  };

  proto.updateDraggable = function () {
    // disable dragging if less than 2 slides. #278
    if (this.options.draggable == '>1') {
      this.isDraggable = this.slides.length > 1;
    } else {
      this.isDraggable = this.options.draggable;
    }
    if (this.isDraggable) {
      this.element.classList.add('is-draggable');
    } else {
      this.element.classList.remove('is-draggable');
    }
  };

  // backwards compatibility
  proto.bindDrag = function () {
    this.options.draggable = true;
    this.updateDraggable();
  };

  proto.unbindDrag = function () {
    this.options.draggable = false;
    this.updateDraggable();
  };

  proto._uiChangeDrag = function () {
    delete this.isFreeScrolling;
  };

  // -------------------------- pointer events -------------------------- //

  proto.pointerDown = function (event, pointer) {
    if (!this.isDraggable) {
      this._pointerDownDefault(event, pointer);
      return;
    }
    var isOkay = this.okayPointerDown(event);
    if (!isOkay) {
      return;
    }

    this._pointerDownPreventDefault(event);
    this.pointerDownFocus(event);
    // blur
    if (document.activeElement != this.element) {
      // do not blur if already focused
      this.pointerDownBlur();
    }

    // stop if it was moving
    this.dragX = this.x;
    this.viewport.classList.add('is-pointer-down');
    // track scrolling
    this.pointerDownScroll = getScrollPosition();
    window.addEventListener('scroll', this);

    this._pointerDownDefault(event, pointer);
  };

  // default pointerDown logic, used for staticClick
  proto._pointerDownDefault = function (event, pointer) {
    // track start event position
    // Safari 9 overrides pageX and pageY. These values needs to be copied. #779
    this.pointerDownPointer = {
      pageX: pointer.pageX,
      pageY: pointer.pageY
    };
    // bind move and end events
    this._bindPostStartEvents(event);
    this.dispatchEvent('pointerDown', event, [pointer]);
  };

  var focusNodes = {
    INPUT: true,
    TEXTAREA: true,
    SELECT: true
  };

  proto.pointerDownFocus = function (event) {
    var isFocusNode = focusNodes[event.target.nodeName];
    if (!isFocusNode) {
      this.focus();
    }
  };

  proto._pointerDownPreventDefault = function (event) {
    var isTouchStart = event.type == 'touchstart';
    var isTouchPointer = event.pointerType == 'touch';
    var isFocusNode = focusNodes[event.target.nodeName];
    if (!isTouchStart && !isTouchPointer && !isFocusNode) {
      event.preventDefault();
    }
  };

  // ----- move ----- //

  proto.hasDragStarted = function (moveVector) {
    return Math.abs(moveVector.x) > this.options.dragThreshold;
  };

  // ----- up ----- //

  proto.pointerUp = function (event, pointer) {
    delete this.isTouchScrolling;
    this.viewport.classList.remove('is-pointer-down');
    this.dispatchEvent('pointerUp', event, [pointer]);
    this._dragPointerUp(event, pointer);
  };

  proto.pointerDone = function () {
    window.removeEventListener('scroll', this);
    delete this.pointerDownScroll;
  };

  // -------------------------- dragging -------------------------- //

  proto.dragStart = function (event, pointer) {
    if (!this.isDraggable) {
      return;
    }
    this.dragStartPosition = this.x;
    this.startAnimation();
    window.removeEventListener('scroll', this);
    this.dispatchEvent('dragStart', event, [pointer]);
  };

  proto.pointerMove = function (event, pointer) {
    var moveVector = this._dragPointerMove(event, pointer);
    this.dispatchEvent('pointerMove', event, [pointer, moveVector]);
    this._dragMove(event, pointer, moveVector);
  };

  proto.dragMove = function (event, pointer, moveVector) {
    if (!this.isDraggable) {
      return;
    }
    event.preventDefault();

    this.previousDragX = this.dragX;
    // reverse if right-to-left
    var direction = this.options.rightToLeft ? -1 : 1;
    if (this.options.wrapAround) {
      // wrap around move. #589
      moveVector.x = moveVector.x % this.slideableWidth;
    }
    var dragX = this.dragStartPosition + moveVector.x * direction;

    if (!this.options.wrapAround && this.slides.length) {
      // slow drag
      var originBound = Math.max(-this.slides[0].target, this.dragStartPosition);
      dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
      var endBound = Math.min(-this.getLastSlide().target, this.dragStartPosition);
      dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
    }

    this.dragX = dragX;

    this.dragMoveTime = new Date();
    this.dispatchEvent('dragMove', event, [pointer, moveVector]);
  };

  proto.dragEnd = function (event, pointer) {
    if (!this.isDraggable) {
      return;
    }
    if (this.options.freeScroll) {
      this.isFreeScrolling = true;
    }
    // set selectedIndex based on where flick will end up
    var index = this.dragEndRestingSelect();

    if (this.options.freeScroll && !this.options.wrapAround) {
      // if free-scroll & not wrap around
      // do not free-scroll if going outside of bounding slides
      // so bounding slides can attract slider, and keep it in bounds
      var restingX = this.getRestingPosition();
      this.isFreeScrolling = -restingX > this.slides[0].target && -restingX < this.getLastSlide().target;
    } else if (!this.options.freeScroll && index == this.selectedIndex) {
      // boost selection if selected index has not changed
      index += this.dragEndBoostSelect();
    }
    delete this.previousDragX;
    // apply selection
    // TODO refactor this, selecting here feels weird
    // HACK, set flag so dragging stays in correct direction
    this.isDragSelect = this.options.wrapAround;
    this.select(index);
    delete this.isDragSelect;
    this.dispatchEvent('dragEnd', event, [pointer]);
  };

  proto.dragEndRestingSelect = function () {
    var restingX = this.getRestingPosition();
    // how far away from selected slide
    var distance = Math.abs(this.getSlideDistance(-restingX, this.selectedIndex));
    // get closet resting going up and going down
    var positiveResting = this._getClosestResting(restingX, distance, 1);
    var negativeResting = this._getClosestResting(restingX, distance, -1);
    // use closer resting for wrap-around
    var index = positiveResting.distance < negativeResting.distance ? positiveResting.index : negativeResting.index;
    return index;
  };

  /**
   * given resting X and distance to selected cell
   * get the distance and index of the closest cell
   * @param {Number} restingX - estimated post-flick resting position
   * @param {Number} distance - distance to selected cell
   * @param {Integer} increment - +1 or -1, going up or down
   * @returns {Object} - { distance: {Number}, index: {Integer} }
   */
  proto._getClosestResting = function (restingX, distance, increment) {
    var index = this.selectedIndex;
    var minDistance = Infinity;
    var condition = this.options.contain && !this.options.wrapAround ?
    // if contain, keep going if distance is equal to minDistance
    function (d, md) {
      return d <= md;
    } : function (d, md) {
      return d < md;
    };
    while (condition(distance, minDistance)) {
      // measure distance to next cell
      index += increment;
      minDistance = distance;
      distance = this.getSlideDistance(-restingX, index);
      if (distance === null) {
        break;
      }
      distance = Math.abs(distance);
    }
    return {
      distance: minDistance,
      // selected was previous index
      index: index - increment
    };
  };

  /**
   * measure distance between x and a slide target
   * @param {Number} x
   * @param {Integer} index - slide index
   */
  proto.getSlideDistance = function (x, index) {
    var len = this.slides.length;
    // wrap around if at least 2 slides
    var isWrapAround = this.options.wrapAround && len > 1;
    var slideIndex = isWrapAround ? utils.modulo(index, len) : index;
    var slide = this.slides[slideIndex];
    if (!slide) {
      return null;
    }
    // add distance for wrap-around slides
    var wrap = isWrapAround ? this.slideableWidth * Math.floor(index / len) : 0;
    return x - (slide.target + wrap);
  };

  proto.dragEndBoostSelect = function () {
    // do not boost if no previousDragX or dragMoveTime
    if (this.previousDragX === undefined || !this.dragMoveTime ||
    // or if drag was held for 100 ms
    new Date() - this.dragMoveTime > 100) {
      return 0;
    }

    var distance = this.getSlideDistance(-this.dragX, this.selectedIndex);
    var delta = this.previousDragX - this.dragX;
    if (distance > 0 && delta > 0) {
      // boost to next if moving towards the right, and positive velocity
      return 1;
    } else if (distance < 0 && delta < 0) {
      // boost to previous if moving towards the left, and negative velocity
      return -1;
    }
    return 0;
  };

  // ----- staticClick ----- //

  proto.staticClick = function (event, pointer) {
    // get clickedCell, if cell was clicked
    var clickedCell = this.getParentCell(event.target);
    var cellElem = clickedCell && clickedCell.element;
    var cellIndex = clickedCell && this.cells.indexOf(clickedCell);
    this.dispatchEvent('staticClick', event, [pointer, cellElem, cellIndex]);
  };

  // ----- scroll ----- //

  proto.onscroll = function () {
    var scroll = getScrollPosition();
    var scrollMoveX = this.pointerDownScroll.x - scroll.x;
    var scrollMoveY = this.pointerDownScroll.y - scroll.y;
    // cancel click/tap if scroll is too much
    if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) {
      this._pointerDone();
    }
  };

  // ----- utils ----- //

  function getScrollPosition() {
    return {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }

  // -----  ----- //

  return Flickity;
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/flickity/js/flickity.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// Flickity main
(function (window, factory) {
  // universal module definition
  /* jshint strict: false */
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/ev-emitter/ev-emitter.js"), __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/get-size/get-size.js"), __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/fizzy-ui-utils/utils.js"), __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/flickity/js/cell.js"), __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/flickity/js/slide.js"), __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/flickity/js/animate.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
      return factory(window, EvEmitter, getSize, utils, Cell, Slide, animatePrototype);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, require('ev-emitter'), require('get-size'), require('fizzy-ui-utils'), require('./cell'), require('./slide'), require('./animate'));
  } else {
    // browser global
    var _Flickity = window.Flickity;

    window.Flickity = factory(window, window.EvEmitter, window.getSize, window.fizzyUIUtils, _Flickity.Cell, _Flickity.Slide, _Flickity.animatePrototype);
  }
})(window, function factory(window, EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {

  'use strict';

  // vars

  var jQuery = window.jQuery;
  var getComputedStyle = window.getComputedStyle;
  var console = window.console;

  function moveElements(elems, toElem) {
    elems = utils.makeArray(elems);
    while (elems.length) {
      toElem.appendChild(elems.shift());
    }
  }

  // -------------------------- Flickity -------------------------- //

  // globally unique identifiers
  var GUID = 0;
  // internal store of all Flickity intances
  var instances = {};

  function Flickity(element, options) {
    var queryElement = utils.getQueryElement(element);
    if (!queryElement) {
      if (console) {
        console.error('Bad element for Flickity: ' + (queryElement || element));
      }
      return;
    }
    this.element = queryElement;
    // do not initialize twice on same element
    if (this.element.flickityGUID) {
      var instance = instances[this.element.flickityGUID];
      instance.option(options);
      return instance;
    }

    // add jQuery
    if (jQuery) {
      this.$element = jQuery(this.element);
    }
    // options
    this.options = utils.extend({}, this.constructor.defaults);
    this.option(options);

    // kick things off
    this._create();
  }

  Flickity.defaults = {
    accessibility: true,
    // adaptiveHeight: false,
    cellAlign: 'center',
    // cellSelector: undefined,
    // contain: false,
    freeScrollFriction: 0.075, // friction when free-scrolling
    friction: 0.28, // friction when selecting
    namespaceJQueryEvents: true,
    // initialIndex: 0,
    percentPosition: true,
    resize: true,
    selectedAttraction: 0.025,
    setGallerySize: true
    // watchCSS: false,
    // wrapAround: false
  };

  // hash of methods triggered on _create()
  Flickity.createMethods = [];

  var proto = Flickity.prototype;
  // inherit EventEmitter
  utils.extend(proto, EvEmitter.prototype);

  proto._create = function () {
    // add id for Flickity.data
    var id = this.guid = ++GUID;
    this.element.flickityGUID = id; // expando
    instances[id] = this; // associate via id
    // initial properties
    this.selectedIndex = 0;
    // how many frames slider has been in same position
    this.restingFrames = 0;
    // initial physics properties
    this.x = 0;
    this.velocity = 0;
    this.originSide = this.options.rightToLeft ? 'right' : 'left';
    // create viewport & slider
    this.viewport = document.createElement('div');
    this.viewport.className = 'flickity-viewport';
    this._createSlider();

    if (this.options.resize || this.options.watchCSS) {
      window.addEventListener('resize', this);
    }

    // add listeners from on option
    for (var eventName in this.options.on) {
      var listener = this.options.on[eventName];
      this.on(eventName, listener);
    }

    Flickity.createMethods.forEach(function (method) {
      this[method]();
    }, this);

    if (this.options.watchCSS) {
      this.watchCSS();
    } else {
      this.activate();
    }
  };

  /**
   * set options
   * @param {Object} opts
   */
  proto.option = function (opts) {
    utils.extend(this.options, opts);
  };

  proto.activate = function () {
    if (this.isActive) {
      return;
    }
    this.isActive = true;
    this.element.classList.add('flickity-enabled');
    if (this.options.rightToLeft) {
      this.element.classList.add('flickity-rtl');
    }

    this.getSize();
    // move initial cell elements so they can be loaded as cells
    var cellElems = this._filterFindCellElements(this.element.children);
    moveElements(cellElems, this.slider);
    this.viewport.appendChild(this.slider);
    this.element.appendChild(this.viewport);
    // get cells from children
    this.reloadCells();

    if (this.options.accessibility) {
      // allow element to focusable
      this.element.tabIndex = 0;
      // listen for key presses
      this.element.addEventListener('keydown', this);
    }

    this.emitEvent('activate');
    this.selectInitialIndex();
    // flag for initial activation, for using initialIndex
    this.isInitActivated = true;
    // ready event. #493
    this.dispatchEvent('ready');
  };

  // slider positions the cells
  proto._createSlider = function () {
    // slider element does all the positioning
    var slider = document.createElement('div');
    slider.className = 'flickity-slider';
    slider.style[this.originSide] = 0;
    this.slider = slider;
  };

  proto._filterFindCellElements = function (elems) {
    return utils.filterFindElements(elems, this.options.cellSelector);
  };

  // goes through all children
  proto.reloadCells = function () {
    // collection of item elements
    this.cells = this._makeCells(this.slider.children);
    this.positionCells();
    this._getWrapShiftCells();
    this.setGallerySize();
  };

  /**
   * turn elements into Flickity.Cells
   * @param {Array or NodeList or HTMLElement} elems
   * @returns {Array} items - collection of new Flickity Cells
   */
  proto._makeCells = function (elems) {
    var cellElems = this._filterFindCellElements(elems);

    // create new Flickity for collection
    var cells = cellElems.map(function (cellElem) {
      return new Cell(cellElem, this);
    }, this);

    return cells;
  };

  proto.getLastCell = function () {
    return this.cells[this.cells.length - 1];
  };

  proto.getLastSlide = function () {
    return this.slides[this.slides.length - 1];
  };

  // positions all cells
  proto.positionCells = function () {
    // size all cells
    this._sizeCells(this.cells);
    // position all cells
    this._positionCells(0);
  };

  /**
   * position certain cells
   * @param {Integer} index - which cell to start with
   */
  proto._positionCells = function (index) {
    index = index || 0;
    // also measure maxCellHeight
    // start 0 if positioning all cells
    this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
    var cellX = 0;
    // get cellX
    if (index > 0) {
      var startCell = this.cells[index - 1];
      cellX = startCell.x + startCell.size.outerWidth;
    }
    var len = this.cells.length;
    for (var i = index; i < len; i++) {
      var cell = this.cells[i];
      cell.setPosition(cellX);
      cellX += cell.size.outerWidth;
      this.maxCellHeight = Math.max(cell.size.outerHeight, this.maxCellHeight);
    }
    // keep track of cellX for wrap-around
    this.slideableWidth = cellX;
    // slides
    this.updateSlides();
    // contain slides target
    this._containSlides();
    // update slidesWidth
    this.slidesWidth = len ? this.getLastSlide().target - this.slides[0].target : 0;
  };

  /**
   * cell.getSize() on multiple cells
   * @param {Array} cells
   */
  proto._sizeCells = function (cells) {
    cells.forEach(function (cell) {
      cell.getSize();
    });
  };

  // --------------------------  -------------------------- //

  proto.updateSlides = function () {
    this.slides = [];
    if (!this.cells.length) {
      return;
    }

    var slide = new Slide(this);
    this.slides.push(slide);
    var isOriginLeft = this.originSide == 'left';
    var nextMargin = isOriginLeft ? 'marginRight' : 'marginLeft';

    var canCellFit = this._getCanCellFit();

    this.cells.forEach(function (cell, i) {
      // just add cell if first cell in slide
      if (!slide.cells.length) {
        slide.addCell(cell);
        return;
      }

      var slideWidth = slide.outerWidth - slide.firstMargin + (cell.size.outerWidth - cell.size[nextMargin]);

      if (canCellFit.call(this, i, slideWidth)) {
        slide.addCell(cell);
      } else {
        // doesn't fit, new slide
        slide.updateTarget();

        slide = new Slide(this);
        this.slides.push(slide);
        slide.addCell(cell);
      }
    }, this);
    // last slide
    slide.updateTarget();
    // update .selectedSlide
    this.updateSelectedSlide();
  };

  proto._getCanCellFit = function () {
    var groupCells = this.options.groupCells;
    if (!groupCells) {
      return function () {
        return false;
      };
    } else if (typeof groupCells == 'number') {
      // group by number. 3 -> [0,1,2], [3,4,5], ...
      var number = parseInt(groupCells, 10);
      return function (i) {
        return i % number !== 0;
      };
    }
    // default, group by width of slide
    // parse '75%
    var percentMatch = typeof groupCells == 'string' && groupCells.match(/^(\d+)%$/);
    var percent = percentMatch ? parseInt(percentMatch[1], 10) / 100 : 1;
    return function (i, slideWidth) {
      return slideWidth <= (this.size.innerWidth + 1) * percent;
    };
  };

  // alias _init for jQuery plugin .flickity()
  proto._init = proto.reposition = function () {
    this.positionCells();
    this.positionSliderAtSelected();
  };

  proto.getSize = function () {
    this.size = getSize(this.element);
    this.setCellAlign();
    this.cursorPosition = this.size.innerWidth * this.cellAlign;
  };

  var cellAlignShorthands = {
    // cell align, then based on origin side
    center: {
      left: 0.5,
      right: 0.5
    },
    left: {
      left: 0,
      right: 1
    },
    right: {
      right: 0,
      left: 1
    }
  };

  proto.setCellAlign = function () {
    var shorthand = cellAlignShorthands[this.options.cellAlign];
    this.cellAlign = shorthand ? shorthand[this.originSide] : this.options.cellAlign;
  };

  proto.setGallerySize = function () {
    if (this.options.setGallerySize) {
      var height = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
      this.viewport.style.height = height + 'px';
    }
  };

  proto._getWrapShiftCells = function () {
    // only for wrap-around
    if (!this.options.wrapAround) {
      return;
    }
    // unshift previous cells
    this._unshiftCells(this.beforeShiftCells);
    this._unshiftCells(this.afterShiftCells);
    // get before cells
    // initial gap
    var gapX = this.cursorPosition;
    var cellIndex = this.cells.length - 1;
    this.beforeShiftCells = this._getGapCells(gapX, cellIndex, -1);
    // get after cells
    // ending gap between last cell and end of gallery viewport
    gapX = this.size.innerWidth - this.cursorPosition;
    // start cloning at first cell, working forwards
    this.afterShiftCells = this._getGapCells(gapX, 0, 1);
  };

  proto._getGapCells = function (gapX, cellIndex, increment) {
    // keep adding cells until the cover the initial gap
    var cells = [];
    while (gapX > 0) {
      var cell = this.cells[cellIndex];
      if (!cell) {
        break;
      }
      cells.push(cell);
      cellIndex += increment;
      gapX -= cell.size.outerWidth;
    }
    return cells;
  };

  // ----- contain ----- //

  // contain cell targets so no excess sliding
  proto._containSlides = function () {
    if (!this.options.contain || this.options.wrapAround || !this.cells.length) {
      return;
    }
    var isRightToLeft = this.options.rightToLeft;
    var beginMargin = isRightToLeft ? 'marginRight' : 'marginLeft';
    var endMargin = isRightToLeft ? 'marginLeft' : 'marginRight';
    var contentWidth = this.slideableWidth - this.getLastCell().size[endMargin];
    // content is less than gallery size
    var isContentSmaller = contentWidth < this.size.innerWidth;
    // bounds
    var beginBound = this.cursorPosition + this.cells[0].size[beginMargin];
    var endBound = contentWidth - this.size.innerWidth * (1 - this.cellAlign);
    // contain each cell target
    this.slides.forEach(function (slide) {
      if (isContentSmaller) {
        // all cells fit inside gallery
        slide.target = contentWidth * this.cellAlign;
      } else {
        // contain to bounds
        slide.target = Math.max(slide.target, beginBound);
        slide.target = Math.min(slide.target, endBound);
      }
    }, this);
  };

  // -----  ----- //

  /**
   * emits events via eventEmitter and jQuery events
   * @param {String} type - name of event
   * @param {Event} event - original event
   * @param {Array} args - extra arguments
   */
  proto.dispatchEvent = function (type, event, args) {
    var emitArgs = event ? [event].concat(args) : args;
    this.emitEvent(type, emitArgs);

    if (jQuery && this.$element) {
      // default trigger with type if no event
      type += this.options.namespaceJQueryEvents ? '.flickity' : '';
      var $event = type;
      if (event) {
        // create jQuery event
        var jQEvent = jQuery.Event(event);
        jQEvent.type = type;
        $event = jQEvent;
      }
      this.$element.trigger($event, args);
    }
  };

  // -------------------------- select -------------------------- //

  /**
   * @param {Integer} index - index of the slide
   * @param {Boolean} isWrap - will wrap-around to last/first if at the end
   * @param {Boolean} isInstant - will immediately set position at selected cell
   */
  proto.select = function (index, isWrap, isInstant) {
    if (!this.isActive) {
      return;
    }
    index = parseInt(index, 10);
    this._wrapSelect(index);

    if (this.options.wrapAround || isWrap) {
      index = utils.modulo(index, this.slides.length);
    }
    // bail if invalid index
    if (!this.slides[index]) {
      return;
    }
    var prevIndex = this.selectedIndex;
    this.selectedIndex = index;
    this.updateSelectedSlide();
    if (isInstant) {
      this.positionSliderAtSelected();
    } else {
      this.startAnimation();
    }
    if (this.options.adaptiveHeight) {
      this.setGallerySize();
    }
    // events
    this.dispatchEvent('select', null, [index]);
    // change event if new index
    if (index != prevIndex) {
      this.dispatchEvent('change', null, [index]);
    }
    // old v1 event name, remove in v3
    this.dispatchEvent('cellSelect');
  };

  // wraps position for wrapAround, to move to closest slide. #113
  proto._wrapSelect = function (index) {
    var len = this.slides.length;
    var isWrapping = this.options.wrapAround && len > 1;
    if (!isWrapping) {
      return index;
    }
    var wrapIndex = utils.modulo(index, len);
    // go to shortest
    var delta = Math.abs(wrapIndex - this.selectedIndex);
    var backWrapDelta = Math.abs(wrapIndex + len - this.selectedIndex);
    var forewardWrapDelta = Math.abs(wrapIndex - len - this.selectedIndex);
    if (!this.isDragSelect && backWrapDelta < delta) {
      index += len;
    } else if (!this.isDragSelect && forewardWrapDelta < delta) {
      index -= len;
    }
    // wrap position so slider is within normal area
    if (index < 0) {
      this.x -= this.slideableWidth;
    } else if (index >= len) {
      this.x += this.slideableWidth;
    }
  };

  proto.previous = function (isWrap, isInstant) {
    this.select(this.selectedIndex - 1, isWrap, isInstant);
  };

  proto.next = function (isWrap, isInstant) {
    this.select(this.selectedIndex + 1, isWrap, isInstant);
  };

  proto.updateSelectedSlide = function () {
    var slide = this.slides[this.selectedIndex];
    // selectedIndex could be outside of slides, if triggered before resize()
    if (!slide) {
      return;
    }
    // unselect previous selected slide
    this.unselectSelectedSlide();
    // update new selected slide
    this.selectedSlide = slide;
    slide.select();
    this.selectedCells = slide.cells;
    this.selectedElements = slide.getCellElements();
    // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
    // Remove in v3?
    this.selectedCell = slide.cells[0];
    this.selectedElement = this.selectedElements[0];
  };

  proto.unselectSelectedSlide = function () {
    if (this.selectedSlide) {
      this.selectedSlide.unselect();
    }
  };

  proto.selectInitialIndex = function () {
    var initialIndex = this.options.initialIndex;
    // already activated, select previous selectedIndex
    if (this.isInitActivated) {
      this.select(this.selectedIndex, false, true);
      return;
    }
    // select with selector string
    if (initialIndex && typeof initialIndex == 'string') {
      var cell = this.queryCell(initialIndex);
      if (cell) {
        this.selectCell(initialIndex, false, true);
        return;
      }
    }

    var index = 0;
    // select with number
    if (initialIndex && this.slides[initialIndex]) {
      index = initialIndex;
    }
    // select instantly
    this.select(index, false, true);
  };

  /**
   * select slide from number or cell element
   * @param {Element or Number} elem
   */
  proto.selectCell = function (value, isWrap, isInstant) {
    // get cell
    var cell = this.queryCell(value);
    if (!cell) {
      return;
    }

    var index = this.getCellSlideIndex(cell);
    this.select(index, isWrap, isInstant);
  };

  proto.getCellSlideIndex = function (cell) {
    // get index of slides that has cell
    for (var i = 0; i < this.slides.length; i++) {
      var slide = this.slides[i];
      var index = slide.cells.indexOf(cell);
      if (index != -1) {
        return i;
      }
    }
  };

  // -------------------------- get cells -------------------------- //

  /**
   * get Flickity.Cell, given an Element
   * @param {Element} elem
   * @returns {Flickity.Cell} item
   */
  proto.getCell = function (elem) {
    // loop through cells to get the one that matches
    for (var i = 0; i < this.cells.length; i++) {
      var cell = this.cells[i];
      if (cell.element == elem) {
        return cell;
      }
    }
  };

  /**
   * get collection of Flickity.Cells, given Elements
   * @param {Element, Array, NodeList} elems
   * @returns {Array} cells - Flickity.Cells
   */
  proto.getCells = function (elems) {
    elems = utils.makeArray(elems);
    var cells = [];
    elems.forEach(function (elem) {
      var cell = this.getCell(elem);
      if (cell) {
        cells.push(cell);
      }
    }, this);
    return cells;
  };

  /**
   * get cell elements
   * @returns {Array} cellElems
   */
  proto.getCellElements = function () {
    return this.cells.map(function (cell) {
      return cell.element;
    });
  };

  /**
   * get parent cell from an element
   * @param {Element} elem
   * @returns {Flickit.Cell} cell
   */
  proto.getParentCell = function (elem) {
    // first check if elem is cell
    var cell = this.getCell(elem);
    if (cell) {
      return cell;
    }
    // try to get parent cell elem
    elem = utils.getParent(elem, '.flickity-slider > *');
    return this.getCell(elem);
  };

  /**
   * get cells adjacent to a slide
   * @param {Integer} adjCount - number of adjacent slides
   * @param {Integer} index - index of slide to start
   * @returns {Array} cells - array of Flickity.Cells
   */
  proto.getAdjacentCellElements = function (adjCount, index) {
    if (!adjCount) {
      return this.selectedSlide.getCellElements();
    }
    index = index === undefined ? this.selectedIndex : index;

    var len = this.slides.length;
    if (1 + adjCount * 2 >= len) {
      return this.getCellElements();
    }

    var cellElems = [];
    for (var i = index - adjCount; i <= index + adjCount; i++) {
      var slideIndex = this.options.wrapAround ? utils.modulo(i, len) : i;
      var slide = this.slides[slideIndex];
      if (slide) {
        cellElems = cellElems.concat(slide.getCellElements());
      }
    }
    return cellElems;
  };

  /**
   * select slide from number or cell element
   * @param {Element, Selector String, or Number} selector
   */
  proto.queryCell = function (selector) {
    if (typeof selector == 'number') {
      // use number as index
      return this.cells[selector];
    }
    if (typeof selector == 'string') {
      // do not select invalid selectors from hash: #123, #/. #791
      if (selector.match(/^[#\.]?[\d\/]/)) {
        return;
      }
      // use string as selector, get element
      selector = this.element.querySelector(selector);
    }
    // get cell from element
    return this.getCell(selector);
  };

  // -------------------------- events -------------------------- //

  proto.uiChange = function () {
    this.emitEvent('uiChange');
  };

  // keep focus on element when child UI elements are clicked
  proto.childUIPointerDown = function (event) {
    // HACK iOS does not allow touch events to bubble up?!
    if (event.type != 'touchstart') {
      event.preventDefault();
    }
    this.focus();
  };

  // ----- resize ----- //

  proto.onresize = function () {
    this.watchCSS();
    this.resize();
  };

  utils.debounceMethod(Flickity, 'onresize', 150);

  proto.resize = function () {
    if (!this.isActive) {
      return;
    }
    this.getSize();
    // wrap values
    if (this.options.wrapAround) {
      this.x = utils.modulo(this.x, this.slideableWidth);
    }
    this.positionCells();
    this._getWrapShiftCells();
    this.setGallerySize();
    this.emitEvent('resize');
    // update selected index for group slides, instant
    // TODO: position can be lost between groups of various numbers
    var selectedElement = this.selectedElements && this.selectedElements[0];
    this.selectCell(selectedElement, false, true);
  };

  // watches the :after property, activates/deactivates
  proto.watchCSS = function () {
    var watchOption = this.options.watchCSS;
    if (!watchOption) {
      return;
    }

    var afterContent = getComputedStyle(this.element, ':after').content;
    // activate if :after { content: 'flickity' }
    if (afterContent.indexOf('flickity') != -1) {
      this.activate();
    } else {
      this.deactivate();
    }
  };

  // ----- keydown ----- //

  // go previous/next if left/right keys pressed
  proto.onkeydown = function (event) {
    // only work if element is in focus
    var isNotFocused = document.activeElement && document.activeElement != this.element;
    if (!this.options.accessibility || isNotFocused) {
      return;
    }

    var handler = Flickity.keyboardHandlers[event.keyCode];
    if (handler) {
      handler.call(this);
    }
  };

  Flickity.keyboardHandlers = {
    // left arrow
    37: function _() {
      var leftMethod = this.options.rightToLeft ? 'next' : 'previous';
      this.uiChange();
      this[leftMethod]();
    },
    // right arrow
    39: function _() {
      var rightMethod = this.options.rightToLeft ? 'previous' : 'next';
      this.uiChange();
      this[rightMethod]();
    }
  };

  // ----- focus ----- //

  proto.focus = function () {
    // TODO remove scrollTo once focus options gets more support
    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#Browser_compatibility
    var prevScrollY = window.pageYOffset;
    this.element.focus({ preventScroll: true });
    // hack to fix scroll jump after focus, #76
    if (window.pageYOffset != prevScrollY) {
      window.scrollTo(window.pageXOffset, prevScrollY);
    }
  };

  // -------------------------- destroy -------------------------- //

  // deactivate all Flickity functionality, but keep stuff available
  proto.deactivate = function () {
    if (!this.isActive) {
      return;
    }
    this.element.classList.remove('flickity-enabled');
    this.element.classList.remove('flickity-rtl');
    this.unselectSelectedSlide();
    // destroy cells
    this.cells.forEach(function (cell) {
      cell.destroy();
    });
    this.element.removeChild(this.viewport);
    // move child elements back into element
    moveElements(this.slider.children, this.element);
    if (this.options.accessibility) {
      this.element.removeAttribute('tabIndex');
      this.element.removeEventListener('keydown', this);
    }
    // set flags
    this.isActive = false;
    this.emitEvent('deactivate');
  };

  proto.destroy = function () {
    this.deactivate();
    window.removeEventListener('resize', this);
    this.allOff();
    this.emitEvent('destroy');
    if (jQuery && this.$element) {
      jQuery.removeData(this.element, 'flickity');
    }
    delete this.element.flickityGUID;
    delete instances[this.guid];
  };

  // -------------------------- prototype -------------------------- //

  utils.extend(proto, animatePrototype);

  // -------------------------- extras -------------------------- //

  /**
   * get Flickity instance from element
   * @param {Element} elem
   * @returns {Flickity}
   */
  Flickity.data = function (elem) {
    elem = utils.getQueryElement(elem);
    var id = elem && elem.flickityGUID;
    return id && instances[id];
  };

  utils.htmlInit(Flickity, 'flickity');

  if (jQuery && jQuery.bridget) {
    jQuery.bridget('flickity', Flickity);
  }

  // set internal jQuery, for Webpack + jQuery v3, #478
  Flickity.setJQuery = function (jq) {
    jQuery = jq;
  };

  Flickity.Cell = Cell;
  Flickity.Slide = Slide;

  return Flickity;
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/flickity/js/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * Flickity v2.2.0
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2018 Metafizzy
 */

(function (window, factory) {
  // universal module definition
  /* jshint strict: false */
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/flickity/js/flickity.js"), __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/flickity/js/drag.js"), __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/flickity/js/prev-next-button.js"), __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/flickity/js/page-dots.js"), __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/flickity/js/player.js"), __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/flickity/js/add-remove-cell.js"), __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/flickity/js/lazyload.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(require('./flickity'), require('./drag'), require('./prev-next-button'), require('./page-dots'), require('./player'), require('./add-remove-cell'), require('./lazyload'));
  }
})(window, function factory(Flickity) {
  /*jshint strict: false*/
  return Flickity;
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/flickity/js/lazyload.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// lazyload
(function (window, factory) {
  // universal module definition
  /* jshint strict: false */
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/flickity/js/flickity.js"), __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/fizzy-ui-utils/utils.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (Flickity, utils) {
      return factory(window, Flickity, utils);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, require('./flickity'), require('fizzy-ui-utils'));
  } else {
    // browser global
    factory(window, window.Flickity, window.fizzyUIUtils);
  }
})(window, function factory(window, Flickity, utils) {
  'use strict';

  Flickity.createMethods.push('_createLazyload');
  var proto = Flickity.prototype;

  proto._createLazyload = function () {
    this.on('select', this.lazyLoad);
  };

  proto.lazyLoad = function () {
    var lazyLoad = this.options.lazyLoad;
    if (!lazyLoad) {
      return;
    }
    // get adjacent cells, use lazyLoad option for adjacent count
    var adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
    var cellElems = this.getAdjacentCellElements(adjCount);
    // get lazy images in those cells
    var lazyImages = [];
    cellElems.forEach(function (cellElem) {
      var lazyCellImages = getCellLazyImages(cellElem);
      lazyImages = lazyImages.concat(lazyCellImages);
    });
    // load lazy images
    lazyImages.forEach(function (img) {
      new LazyLoader(img, this);
    }, this);
  };

  function getCellLazyImages(cellElem) {
    // check if cell element is lazy image
    if (cellElem.nodeName == 'IMG') {
      var lazyloadAttr = cellElem.getAttribute('data-flickity-lazyload');
      var srcAttr = cellElem.getAttribute('data-flickity-lazyload-src');
      var srcsetAttr = cellElem.getAttribute('data-flickity-lazyload-srcset');
      if (lazyloadAttr || srcAttr || srcsetAttr) {
        return [cellElem];
      }
    }
    // select lazy images in cell
    var lazySelector = 'img[data-flickity-lazyload], ' + 'img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]';
    var imgs = cellElem.querySelectorAll(lazySelector);
    return utils.makeArray(imgs);
  }

  // -------------------------- LazyLoader -------------------------- //

  /**
   * class to handle loading images
   */
  function LazyLoader(img, flickity) {
    this.img = img;
    this.flickity = flickity;
    this.load();
  }

  LazyLoader.prototype.handleEvent = utils.handleEvent;

  LazyLoader.prototype.load = function () {
    this.img.addEventListener('load', this);
    this.img.addEventListener('error', this);
    // get src & srcset
    var src = this.img.getAttribute('data-flickity-lazyload') || this.img.getAttribute('data-flickity-lazyload-src');
    var srcset = this.img.getAttribute('data-flickity-lazyload-srcset');
    // set src & serset
    this.img.src = src;
    if (srcset) {
      this.img.setAttribute('srcset', srcset);
    }
    // remove attr
    this.img.removeAttribute('data-flickity-lazyload');
    this.img.removeAttribute('data-flickity-lazyload-src');
    this.img.removeAttribute('data-flickity-lazyload-srcset');
  };

  LazyLoader.prototype.onload = function (event) {
    this.complete(event, 'flickity-lazyloaded');
  };

  LazyLoader.prototype.onerror = function (event) {
    this.complete(event, 'flickity-lazyerror');
  };

  LazyLoader.prototype.complete = function (event, className) {
    // unbind events
    this.img.removeEventListener('load', this);
    this.img.removeEventListener('error', this);

    var cell = this.flickity.getParentCell(this.img);
    var cellElem = cell && cell.element;
    this.flickity.cellSizeChange(cellElem);

    this.img.classList.add(className);
    this.flickity.dispatchEvent('lazyLoad', event, cellElem);
  };

  // -----  ----- //

  Flickity.LazyLoader = LazyLoader;

  return Flickity;
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/flickity/js/page-dots.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// page dots
(function (window, factory) {
  // universal module definition
  /* jshint strict: false */
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/flickity/js/flickity.js"), __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/unipointer/unipointer.js"), __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/fizzy-ui-utils/utils.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (Flickity, Unipointer, utils) {
      return factory(window, Flickity, Unipointer, utils);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, require('./flickity'), require('unipointer'), require('fizzy-ui-utils'));
  } else {
    // browser global
    factory(window, window.Flickity, window.Unipointer, window.fizzyUIUtils);
  }
})(window, function factory(window, Flickity, Unipointer, utils) {

  // -------------------------- PageDots -------------------------- //

  'use strict';

  function PageDots(parent) {
    this.parent = parent;
    this._create();
  }

  PageDots.prototype = Object.create(Unipointer.prototype);

  PageDots.prototype._create = function () {
    // create holder element
    this.holder = document.createElement('ol');
    this.holder.className = 'flickity-page-dots';
    // create dots, array of elements
    this.dots = [];
    // events
    this.handleClick = this.onClick.bind(this);
    this.on('pointerDown', this.parent.childUIPointerDown.bind(this.parent));
  };

  PageDots.prototype.activate = function () {
    this.setDots();
    this.holder.addEventListener('click', this.handleClick);
    this.bindStartEvent(this.holder);
    // add to DOM
    this.parent.element.appendChild(this.holder);
  };

  PageDots.prototype.deactivate = function () {
    this.holder.removeEventListener('click', this.handleClick);
    this.unbindStartEvent(this.holder);
    // remove from DOM
    this.parent.element.removeChild(this.holder);
  };

  PageDots.prototype.setDots = function () {
    // get difference between number of slides and number of dots
    var delta = this.parent.slides.length - this.dots.length;
    if (delta > 0) {
      this.addDots(delta);
    } else if (delta < 0) {
      this.removeDots(-delta);
    }
  };

  PageDots.prototype.addDots = function (count) {
    var fragment = document.createDocumentFragment();
    var newDots = [];
    var length = this.dots.length;
    var max = length + count;

    for (var i = length; i < max; i++) {
      var dot = document.createElement('li');
      dot.className = 'dot';
      dot.setAttribute('aria-label', 'Page dot ' + (i + 1));
      fragment.appendChild(dot);
      newDots.push(dot);
    }

    this.holder.appendChild(fragment);
    this.dots = this.dots.concat(newDots);
  };

  PageDots.prototype.removeDots = function (count) {
    // remove from this.dots collection
    var removeDots = this.dots.splice(this.dots.length - count, count);
    // remove from DOM
    removeDots.forEach(function (dot) {
      this.holder.removeChild(dot);
    }, this);
  };

  PageDots.prototype.updateSelected = function () {
    // remove selected class on previous
    if (this.selectedDot) {
      this.selectedDot.className = 'dot';
      this.selectedDot.removeAttribute('aria-current');
    }
    // don't proceed if no dots
    if (!this.dots.length) {
      return;
    }
    this.selectedDot = this.dots[this.parent.selectedIndex];
    this.selectedDot.className = 'dot is-selected';
    this.selectedDot.setAttribute('aria-current', 'step');
  };

  PageDots.prototype.onTap = // old method name, backwards-compatible
  PageDots.prototype.onClick = function (event) {
    var target = event.target;
    // only care about dot clicks
    if (target.nodeName != 'LI') {
      return;
    }

    this.parent.uiChange();
    var index = this.dots.indexOf(target);
    this.parent.select(index);
  };

  PageDots.prototype.destroy = function () {
    this.deactivate();
    this.allOff();
  };

  Flickity.PageDots = PageDots;

  // -------------------------- Flickity -------------------------- //

  utils.extend(Flickity.defaults, {
    pageDots: true
  });

  Flickity.createMethods.push('_createPageDots');

  var proto = Flickity.prototype;

  proto._createPageDots = function () {
    if (!this.options.pageDots) {
      return;
    }
    this.pageDots = new PageDots(this);
    // events
    this.on('activate', this.activatePageDots);
    this.on('select', this.updateSelectedPageDots);
    this.on('cellChange', this.updatePageDots);
    this.on('resize', this.updatePageDots);
    this.on('deactivate', this.deactivatePageDots);
  };

  proto.activatePageDots = function () {
    this.pageDots.activate();
  };

  proto.updateSelectedPageDots = function () {
    this.pageDots.updateSelected();
  };

  proto.updatePageDots = function () {
    this.pageDots.setDots();
  };

  proto.deactivatePageDots = function () {
    this.pageDots.deactivate();
  };

  // -----  ----- //

  Flickity.PageDots = PageDots;

  return Flickity;
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/flickity/js/player.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// player & autoPlay
(function (window, factory) {
  // universal module definition
  /* jshint strict: false */
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/ev-emitter/ev-emitter.js"), __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/fizzy-ui-utils/utils.js"), __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/flickity/js/flickity.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (EvEmitter, utils, Flickity) {
      return factory(EvEmitter, utils, Flickity);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(require('ev-emitter'), require('fizzy-ui-utils'), require('./flickity'));
  } else {
    // browser global
    factory(window.EvEmitter, window.fizzyUIUtils, window.Flickity);
  }
})(window, function factory(EvEmitter, utils, Flickity) {

  'use strict';

  // -------------------------- Player -------------------------- //

  function Player(parent) {
    this.parent = parent;
    this.state = 'stopped';
    // visibility change event handler
    this.onVisibilityChange = this.visibilityChange.bind(this);
    this.onVisibilityPlay = this.visibilityPlay.bind(this);
  }

  Player.prototype = Object.create(EvEmitter.prototype);

  // start play
  Player.prototype.play = function () {
    if (this.state == 'playing') {
      return;
    }
    // do not play if page is hidden, start playing when page is visible
    var isPageHidden = document.hidden;
    if (isPageHidden) {
      document.addEventListener('visibilitychange', this.onVisibilityPlay);
      return;
    }

    this.state = 'playing';
    // listen to visibility change
    document.addEventListener('visibilitychange', this.onVisibilityChange);
    // start ticking
    this.tick();
  };

  Player.prototype.tick = function () {
    // do not tick if not playing
    if (this.state != 'playing') {
      return;
    }

    var time = this.parent.options.autoPlay;
    // default to 3 seconds
    time = typeof time == 'number' ? time : 3000;
    var _this = this;
    // HACK: reset ticks if stopped and started within interval
    this.clear();
    this.timeout = setTimeout(function () {
      _this.parent.next(true);
      _this.tick();
    }, time);
  };

  Player.prototype.stop = function () {
    this.state = 'stopped';
    this.clear();
    // remove visibility change event
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  };

  Player.prototype.clear = function () {
    clearTimeout(this.timeout);
  };

  Player.prototype.pause = function () {
    if (this.state == 'playing') {
      this.state = 'paused';
      this.clear();
    }
  };

  Player.prototype.unpause = function () {
    // re-start play if paused
    if (this.state == 'paused') {
      this.play();
    }
  };

  // pause if page visibility is hidden, unpause if visible
  Player.prototype.visibilityChange = function () {
    var isPageHidden = document.hidden;
    this[isPageHidden ? 'pause' : 'unpause']();
  };

  Player.prototype.visibilityPlay = function () {
    this.play();
    document.removeEventListener('visibilitychange', this.onVisibilityPlay);
  };

  // -------------------------- Flickity -------------------------- //

  utils.extend(Flickity.defaults, {
    pauseAutoPlayOnHover: true
  });

  Flickity.createMethods.push('_createPlayer');
  var proto = Flickity.prototype;

  proto._createPlayer = function () {
    this.player = new Player(this);

    this.on('activate', this.activatePlayer);
    this.on('uiChange', this.stopPlayer);
    this.on('pointerDown', this.stopPlayer);
    this.on('deactivate', this.deactivatePlayer);
  };

  proto.activatePlayer = function () {
    if (!this.options.autoPlay) {
      return;
    }
    this.player.play();
    this.element.addEventListener('mouseenter', this);
  };

  // Player API, don't hate the ... thanks I know where the door is

  proto.playPlayer = function () {
    this.player.play();
  };

  proto.stopPlayer = function () {
    this.player.stop();
  };

  proto.pausePlayer = function () {
    this.player.pause();
  };

  proto.unpausePlayer = function () {
    this.player.unpause();
  };

  proto.deactivatePlayer = function () {
    this.player.stop();
    this.element.removeEventListener('mouseenter', this);
  };

  // ----- mouseenter/leave ----- //

  // pause auto-play on hover
  proto.onmouseenter = function () {
    if (!this.options.pauseAutoPlayOnHover) {
      return;
    }
    this.player.pause();
    this.element.addEventListener('mouseleave', this);
  };

  // resume auto-play on hover off
  proto.onmouseleave = function () {
    this.player.unpause();
    this.element.removeEventListener('mouseleave', this);
  };

  // -----  ----- //

  Flickity.Player = Player;

  return Flickity;
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/flickity/js/prev-next-button.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// prev/next buttons
(function (window, factory) {
  // universal module definition
  /* jshint strict: false */
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/flickity/js/flickity.js"), __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/unipointer/unipointer.js"), __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/fizzy-ui-utils/utils.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (Flickity, Unipointer, utils) {
      return factory(window, Flickity, Unipointer, utils);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, require('./flickity'), require('unipointer'), require('fizzy-ui-utils'));
  } else {
    // browser global
    factory(window, window.Flickity, window.Unipointer, window.fizzyUIUtils);
  }
})(window, function factory(window, Flickity, Unipointer, utils) {
  'use strict';

  var svgURI = 'http://www.w3.org/2000/svg';

  // -------------------------- PrevNextButton -------------------------- //

  function PrevNextButton(direction, parent) {
    this.direction = direction;
    this.parent = parent;
    this._create();
  }

  PrevNextButton.prototype = Object.create(Unipointer.prototype);

  PrevNextButton.prototype._create = function () {
    // properties
    this.isEnabled = true;
    this.isPrevious = this.direction == -1;
    var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
    this.isLeft = this.direction == leftDirection;

    var element = this.element = document.createElement('button');
    element.className = 'flickity-button flickity-prev-next-button';
    element.className += this.isPrevious ? ' previous' : ' next';
    // prevent button from submitting form http://stackoverflow.com/a/10836076/182183
    element.setAttribute('type', 'button');
    // init as disabled
    this.disable();

    element.setAttribute('aria-label', this.isPrevious ? 'Previous' : 'Next');

    // create arrow
    var svg = this.createSVG();
    element.appendChild(svg);
    // events
    this.parent.on('select', this.update.bind(this));
    this.on('pointerDown', this.parent.childUIPointerDown.bind(this.parent));
  };

  PrevNextButton.prototype.activate = function () {
    this.bindStartEvent(this.element);
    this.element.addEventListener('click', this);
    // add to DOM
    this.parent.element.appendChild(this.element);
  };

  PrevNextButton.prototype.deactivate = function () {
    // remove from DOM
    this.parent.element.removeChild(this.element);
    // click events
    this.unbindStartEvent(this.element);
    this.element.removeEventListener('click', this);
  };

  PrevNextButton.prototype.createSVG = function () {
    var svg = document.createElementNS(svgURI, 'svg');
    svg.setAttribute('class', 'flickity-button-icon');
    svg.setAttribute('viewBox', '0 0 100 100');
    var path = document.createElementNS(svgURI, 'path');
    var pathMovements = getArrowMovements(this.parent.options.arrowShape);
    path.setAttribute('d', pathMovements);
    path.setAttribute('class', 'arrow');
    // rotate arrow
    if (!this.isLeft) {
      path.setAttribute('transform', 'translate(100, 100) rotate(180) ');
    }
    svg.appendChild(path);
    return svg;
  };

  // get SVG path movmement
  function getArrowMovements(shape) {
    // use shape as movement if string
    if (typeof shape == 'string') {
      return shape;
    }
    // create movement string
    return 'M ' + shape.x0 + ',50' + ' L ' + shape.x1 + ',' + (shape.y1 + 50) + ' L ' + shape.x2 + ',' + (shape.y2 + 50) + ' L ' + shape.x3 + ',50 ' + ' L ' + shape.x2 + ',' + (50 - shape.y2) + ' L ' + shape.x1 + ',' + (50 - shape.y1) + ' Z';
  }

  PrevNextButton.prototype.handleEvent = utils.handleEvent;

  PrevNextButton.prototype.onclick = function () {
    if (!this.isEnabled) {
      return;
    }
    this.parent.uiChange();
    var method = this.isPrevious ? 'previous' : 'next';
    this.parent[method]();
  };

  // -----  ----- //

  PrevNextButton.prototype.enable = function () {
    if (this.isEnabled) {
      return;
    }
    this.element.disabled = false;
    this.isEnabled = true;
  };

  PrevNextButton.prototype.disable = function () {
    if (!this.isEnabled) {
      return;
    }
    this.element.disabled = true;
    this.isEnabled = false;
  };

  PrevNextButton.prototype.update = function () {
    // index of first or last slide, if previous or next
    var slides = this.parent.slides;
    // enable is wrapAround and at least 2 slides
    if (this.parent.options.wrapAround && slides.length > 1) {
      this.enable();
      return;
    }
    var lastIndex = slides.length ? slides.length - 1 : 0;
    var boundIndex = this.isPrevious ? 0 : lastIndex;
    var method = this.parent.selectedIndex == boundIndex ? 'disable' : 'enable';
    this[method]();
  };

  PrevNextButton.prototype.destroy = function () {
    this.deactivate();
    this.allOff();
  };

  // -------------------------- Flickity prototype -------------------------- //

  utils.extend(Flickity.defaults, {
    prevNextButtons: true,
    arrowShape: {
      x0: 10,
      x1: 60, y1: 50,
      x2: 70, y2: 40,
      x3: 30
    }
  });

  Flickity.createMethods.push('_createPrevNextButtons');
  var proto = Flickity.prototype;

  proto._createPrevNextButtons = function () {
    if (!this.options.prevNextButtons) {
      return;
    }

    this.prevButton = new PrevNextButton(-1, this);
    this.nextButton = new PrevNextButton(1, this);

    this.on('activate', this.activatePrevNextButtons);
  };

  proto.activatePrevNextButtons = function () {
    this.prevButton.activate();
    this.nextButton.activate();
    this.on('deactivate', this.deactivatePrevNextButtons);
  };

  proto.deactivatePrevNextButtons = function () {
    this.prevButton.deactivate();
    this.nextButton.deactivate();
    this.off('deactivate', this.deactivatePrevNextButtons);
  };

  // --------------------------  -------------------------- //

  Flickity.PrevNextButton = PrevNextButton;

  return Flickity;
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/flickity/js/slide.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// slide
(function (window, factory) {
  // universal module definition
  /* jshint strict: false */
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.Slide = factory();
  }
})(window, function factory() {
  'use strict';

  function Slide(parent) {
    this.parent = parent;
    this.isOriginLeft = parent.originSide == 'left';
    this.cells = [];
    this.outerWidth = 0;
    this.height = 0;
  }

  var proto = Slide.prototype;

  proto.addCell = function (cell) {
    this.cells.push(cell);
    this.outerWidth += cell.size.outerWidth;
    this.height = Math.max(cell.size.outerHeight, this.height);
    // first cell stuff
    if (this.cells.length == 1) {
      this.x = cell.x; // x comes from first cell
      var beginMargin = this.isOriginLeft ? 'marginLeft' : 'marginRight';
      this.firstMargin = cell.size[beginMargin];
    }
  };

  proto.updateTarget = function () {
    var endMargin = this.isOriginLeft ? 'marginRight' : 'marginLeft';
    var lastCell = this.getLastCell();
    var lastMargin = lastCell ? lastCell.size[endMargin] : 0;
    var slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
    this.target = this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
  };

  proto.getLastCell = function () {
    return this.cells[this.cells.length - 1];
  };

  proto.select = function () {
    this.cells.forEach(function (cell) {
      cell.select();
    });
  };

  proto.unselect = function () {
    this.cells.forEach(function (cell) {
      cell.unselect();
    });
  };

  proto.getCellElements = function () {
    return this.cells.map(function (cell) {
      return cell.element;
    });
  };

  return Slide;
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/get-size/get-size.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */

/* jshint browser: true, strict: true, undef: true, unused: true */
/* globals console: false */

(function (window, factory) {
  /* jshint strict: false */ /* globals define, module */
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.getSize = factory();
  }
})(window, function factory() {
  'use strict';

  // -------------------------- helpers -------------------------- //

  // get a number from a string, not a percentage

  function getStyleSize(value) {
    var num = parseFloat(value);
    // not a percent like '100%', and a number
    var isValid = value.indexOf('%') == -1 && !isNaN(num);
    return isValid && num;
  }

  function noop() {}

  var logError = typeof console == 'undefined' ? noop : function (message) {
    console.error(message);
  };

  // -------------------------- measurements -------------------------- //

  var measurements = ['paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom', 'borderLeftWidth', 'borderRightWidth', 'borderTopWidth', 'borderBottomWidth'];

  var measurementsLength = measurements.length;

  function getZeroSize() {
    var size = {
      width: 0,
      height: 0,
      innerWidth: 0,
      innerHeight: 0,
      outerWidth: 0,
      outerHeight: 0
    };
    for (var i = 0; i < measurementsLength; i++) {
      var measurement = measurements[i];
      size[measurement] = 0;
    }
    return size;
  }

  // -------------------------- getStyle -------------------------- //

  /**
   * getStyle, get style of element, check for Firefox bug
   * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
   */
  function getStyle(elem) {
    var style = getComputedStyle(elem);
    if (!style) {
      logError('Style returned ' + style + '. Are you running this code in a hidden iframe on Firefox? ' + 'See https://bit.ly/getsizebug1');
    }
    return style;
  }

  // -------------------------- setup -------------------------- //

  var isSetup = false;

  var isBoxSizeOuter;

  /**
   * setup
   * check isBoxSizerOuter
   * do on first getSize() rather than on page load for Firefox bug
   */
  function setup() {
    // setup once
    if (isSetup) {
      return;
    }
    isSetup = true;

    // -------------------------- box sizing -------------------------- //

    /**
     * Chrome & Safari measure the outer-width on style.width on border-box elems
     * IE11 & Firefox<29 measures the inner-width
     */
    var div = document.createElement('div');
    div.style.width = '200px';
    div.style.padding = '1px 2px 3px 4px';
    div.style.borderStyle = 'solid';
    div.style.borderWidth = '1px 2px 3px 4px';
    div.style.boxSizing = 'border-box';

    var body = document.body || document.documentElement;
    body.appendChild(div);
    var style = getStyle(div);
    // round value for browser zoom. desandro/masonry#928
    isBoxSizeOuter = Math.round(getStyleSize(style.width)) == 200;
    getSize.isBoxSizeOuter = isBoxSizeOuter;

    body.removeChild(div);
  }

  // -------------------------- getSize -------------------------- //

  function getSize(elem) {
    setup();

    // use querySeletor if elem is string
    if (typeof elem == 'string') {
      elem = document.querySelector(elem);
    }

    // do not proceed on non-objects
    if (!elem || (typeof elem === 'undefined' ? 'undefined' : _typeof(elem)) != 'object' || !elem.nodeType) {
      return;
    }

    var style = getStyle(elem);

    // if hidden, everything is 0
    if (style.display == 'none') {
      return getZeroSize();
    }

    var size = {};
    size.width = elem.offsetWidth;
    size.height = elem.offsetHeight;

    var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

    // get all measurements
    for (var i = 0; i < measurementsLength; i++) {
      var measurement = measurements[i];
      var value = style[measurement];
      var num = parseFloat(value);
      // any 'auto', 'medium' value will be 0
      size[measurement] = !isNaN(num) ? num : 0;
    }

    var paddingWidth = size.paddingLeft + size.paddingRight;
    var paddingHeight = size.paddingTop + size.paddingBottom;
    var marginWidth = size.marginLeft + size.marginRight;
    var marginHeight = size.marginTop + size.marginBottom;
    var borderWidth = size.borderLeftWidth + size.borderRightWidth;
    var borderHeight = size.borderTopWidth + size.borderBottomWidth;

    var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

    // overwrite width and height if we can get it from style
    var styleWidth = getStyleSize(style.width);
    if (styleWidth !== false) {
      size.width = styleWidth + (
      // add padding and border unless it's already including it
      isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth);
    }

    var styleHeight = getStyleSize(style.height);
    if (styleHeight !== false) {
      size.height = styleHeight + (
      // add padding and border unless it's already including it
      isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight);
    }

    size.innerWidth = size.width - (paddingWidth + borderWidth);
    size.innerHeight = size.height - (paddingHeight + borderHeight);

    size.outerWidth = size.width + marginWidth;
    size.outerHeight = size.height + marginHeight;

    return size;
  }

  return getSize;
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/unidragger/unidragger.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * Unidragger v2.3.0
 * Draggable base class
 * MIT license
 */

/*jshint browser: true, unused: true, undef: true, strict: true */

(function (window, factory) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */

  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/unipointer/unipointer.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (Unipointer) {
      return factory(window, Unipointer);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, require('unipointer'));
  } else {
    // browser global
    window.Unidragger = factory(window, window.Unipointer);
  }
})(window, function factory(window, Unipointer) {

  'use strict';

  // -------------------------- Unidragger -------------------------- //

  function Unidragger() {}

  // inherit Unipointer & EvEmitter
  var proto = Unidragger.prototype = Object.create(Unipointer.prototype);

  // ----- bind start ----- //

  proto.bindHandles = function () {
    this._bindHandles(true);
  };

  proto.unbindHandles = function () {
    this._bindHandles(false);
  };

  /**
   * Add or remove start event
   * @param {Boolean} isAdd
   */
  proto._bindHandles = function (isAdd) {
    // munge isAdd, default to true
    isAdd = isAdd === undefined ? true : isAdd;
    // bind each handle
    var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';
    var touchAction = isAdd ? this._touchActionValue : '';
    for (var i = 0; i < this.handles.length; i++) {
      var handle = this.handles[i];
      this._bindStartEvent(handle, isAdd);
      handle[bindMethod]('click', this);
      // touch-action: none to override browser touch gestures. metafizzy/flickity#540
      if (window.PointerEvent) {
        handle.style.touchAction = touchAction;
      }
    }
  };

  // prototype so it can be overwriteable by Flickity
  proto._touchActionValue = 'none';

  // ----- start event ----- //

  /**
   * pointer start
   * @param {Event} event
   * @param {Event or Touch} pointer
   */
  proto.pointerDown = function (event, pointer) {
    var isOkay = this.okayPointerDown(event);
    if (!isOkay) {
      return;
    }
    // track start event position
    this.pointerDownPointer = pointer;

    event.preventDefault();
    this.pointerDownBlur();
    // bind move and end events
    this._bindPostStartEvents(event);
    this.emitEvent('pointerDown', [event, pointer]);
  };

  // nodes that have text fields
  var cursorNodes = {
    TEXTAREA: true,
    INPUT: true,
    SELECT: true,
    OPTION: true
  };

  // input types that do not have text fields
  var clickTypes = {
    radio: true,
    checkbox: true,
    button: true,
    submit: true,
    image: true,
    file: true
  };

  // dismiss inputs with text fields. flickity#403, flickity#404
  proto.okayPointerDown = function (event) {
    var isCursorNode = cursorNodes[event.target.nodeName];
    var isClickType = clickTypes[event.target.type];
    var isOkay = !isCursorNode || isClickType;
    if (!isOkay) {
      this._pointerReset();
    }
    return isOkay;
  };

  // kludge to blur previously focused input
  proto.pointerDownBlur = function () {
    var focused = document.activeElement;
    // do not blur body for IE10, metafizzy/flickity#117
    var canBlur = focused && focused.blur && focused != document.body;
    if (canBlur) {
      focused.blur();
    }
  };

  // ----- move event ----- //

  /**
   * drag move
   * @param {Event} event
   * @param {Event or Touch} pointer
   */
  proto.pointerMove = function (event, pointer) {
    var moveVector = this._dragPointerMove(event, pointer);
    this.emitEvent('pointerMove', [event, pointer, moveVector]);
    this._dragMove(event, pointer, moveVector);
  };

  // base pointer move logic
  proto._dragPointerMove = function (event, pointer) {
    var moveVector = {
      x: pointer.pageX - this.pointerDownPointer.pageX,
      y: pointer.pageY - this.pointerDownPointer.pageY
    };
    // start drag if pointer has moved far enough to start drag
    if (!this.isDragging && this.hasDragStarted(moveVector)) {
      this._dragStart(event, pointer);
    }
    return moveVector;
  };

  // condition if pointer has moved far enough to start drag
  proto.hasDragStarted = function (moveVector) {
    return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
  };

  // ----- end event ----- //

  /**
   * pointer up
   * @param {Event} event
   * @param {Event or Touch} pointer
   */
  proto.pointerUp = function (event, pointer) {
    this.emitEvent('pointerUp', [event, pointer]);
    this._dragPointerUp(event, pointer);
  };

  proto._dragPointerUp = function (event, pointer) {
    if (this.isDragging) {
      this._dragEnd(event, pointer);
    } else {
      // pointer didn't move enough for drag to start
      this._staticClick(event, pointer);
    }
  };

  // -------------------------- drag -------------------------- //

  // dragStart
  proto._dragStart = function (event, pointer) {
    this.isDragging = true;
    // prevent clicks
    this.isPreventingClicks = true;
    this.dragStart(event, pointer);
  };

  proto.dragStart = function (event, pointer) {
    this.emitEvent('dragStart', [event, pointer]);
  };

  // dragMove
  proto._dragMove = function (event, pointer, moveVector) {
    // do not drag if not dragging yet
    if (!this.isDragging) {
      return;
    }

    this.dragMove(event, pointer, moveVector);
  };

  proto.dragMove = function (event, pointer, moveVector) {
    event.preventDefault();
    this.emitEvent('dragMove', [event, pointer, moveVector]);
  };

  // dragEnd
  proto._dragEnd = function (event, pointer) {
    // set flags
    this.isDragging = false;
    // re-enable clicking async
    setTimeout(function () {
      delete this.isPreventingClicks;
    }.bind(this));

    this.dragEnd(event, pointer);
  };

  proto.dragEnd = function (event, pointer) {
    this.emitEvent('dragEnd', [event, pointer]);
  };

  // ----- onclick ----- //

  // handle all clicks and prevent clicks when dragging
  proto.onclick = function (event) {
    if (this.isPreventingClicks) {
      event.preventDefault();
    }
  };

  // ----- staticClick ----- //

  // triggered after pointer down & up with no/tiny movement
  proto._staticClick = function (event, pointer) {
    // ignore emulated mouse up clicks
    if (this.isIgnoringMouseUp && event.type == 'mouseup') {
      return;
    }

    this.staticClick(event, pointer);

    // set flag for emulated clicks 300ms after touchend
    if (event.type != 'mouseup') {
      this.isIgnoringMouseUp = true;
      // reset flag after 300ms
      setTimeout(function () {
        delete this.isIgnoringMouseUp;
      }.bind(this), 400);
    }
  };

  proto.staticClick = function (event, pointer) {
    this.emitEvent('staticClick', [event, pointer]);
  };

  // ----- utils ----- //

  Unidragger.getPointerPoint = Unipointer.getPointerPoint;

  // -----  ----- //

  return Unidragger;
});

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/unipointer/unipointer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * Unipointer v2.3.0
 * base class for doing one thing with pointer event
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

(function (window, factory) {
  // universal module definition
  /* jshint strict: false */ /*global define, module, require */
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/ev-emitter/ev-emitter.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (EvEmitter) {
      return factory(window, EvEmitter);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, require('ev-emitter'));
  } else {
    // browser global
    window.Unipointer = factory(window, window.EvEmitter);
  }
})(window, function factory(window, EvEmitter) {

  'use strict';

  function noop() {}

  function Unipointer() {}

  // inherit EvEmitter
  var proto = Unipointer.prototype = Object.create(EvEmitter.prototype);

  proto.bindStartEvent = function (elem) {
    this._bindStartEvent(elem, true);
  };

  proto.unbindStartEvent = function (elem) {
    this._bindStartEvent(elem, false);
  };

  /**
   * Add or remove start event
   * @param {Boolean} isAdd - remove if falsey
   */
  proto._bindStartEvent = function (elem, isAdd) {
    // munge isAdd, default to true
    isAdd = isAdd === undefined ? true : isAdd;
    var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';

    // default to mouse events
    var startEvent = 'mousedown';
    if (window.PointerEvent) {
      // Pointer Events
      startEvent = 'pointerdown';
    } else if ('ontouchstart' in window) {
      // Touch Events. iOS Safari
      startEvent = 'touchstart';
    }
    elem[bindMethod](startEvent, this);
  };

  // trigger handler methods for events
  proto.handleEvent = function (event) {
    var method = 'on' + event.type;
    if (this[method]) {
      this[method](event);
    }
  };

  // returns the touch that we're keeping track of
  proto.getTouch = function (touches) {
    for (var i = 0; i < touches.length; i++) {
      var touch = touches[i];
      if (touch.identifier == this.pointerIdentifier) {
        return touch;
      }
    }
  };

  // ----- start event ----- //

  proto.onmousedown = function (event) {
    // dismiss clicks from right or middle buttons
    var button = event.button;
    if (button && button !== 0 && button !== 1) {
      return;
    }
    this._pointerDown(event, event);
  };

  proto.ontouchstart = function (event) {
    this._pointerDown(event, event.changedTouches[0]);
  };

  proto.onpointerdown = function (event) {
    this._pointerDown(event, event);
  };

  /**
   * pointer start
   * @param {Event} event
   * @param {Event or Touch} pointer
   */
  proto._pointerDown = function (event, pointer) {
    // dismiss right click and other pointers
    // button = 0 is okay, 1-4 not
    if (event.button || this.isPointerDown) {
      return;
    }

    this.isPointerDown = true;
    // save pointer identifier to match up touch events
    this.pointerIdentifier = pointer.pointerId !== undefined ?
    // pointerId for pointer events, touch.indentifier for touch events
    pointer.pointerId : pointer.identifier;

    this.pointerDown(event, pointer);
  };

  proto.pointerDown = function (event, pointer) {
    this._bindPostStartEvents(event);
    this.emitEvent('pointerDown', [event, pointer]);
  };

  // hash of events to be bound after start event
  var postStartEvents = {
    mousedown: ['mousemove', 'mouseup'],
    touchstart: ['touchmove', 'touchend', 'touchcancel'],
    pointerdown: ['pointermove', 'pointerup', 'pointercancel']
  };

  proto._bindPostStartEvents = function (event) {
    if (!event) {
      return;
    }
    // get proper events to match start event
    var events = postStartEvents[event.type];
    // bind events to node
    events.forEach(function (eventName) {
      window.addEventListener(eventName, this);
    }, this);
    // save these arguments
    this._boundPointerEvents = events;
  };

  proto._unbindPostStartEvents = function () {
    // check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
    if (!this._boundPointerEvents) {
      return;
    }
    this._boundPointerEvents.forEach(function (eventName) {
      window.removeEventListener(eventName, this);
    }, this);

    delete this._boundPointerEvents;
  };

  // ----- move event ----- //

  proto.onmousemove = function (event) {
    this._pointerMove(event, event);
  };

  proto.onpointermove = function (event) {
    if (event.pointerId == this.pointerIdentifier) {
      this._pointerMove(event, event);
    }
  };

  proto.ontouchmove = function (event) {
    var touch = this.getTouch(event.changedTouches);
    if (touch) {
      this._pointerMove(event, touch);
    }
  };

  /**
   * pointer move
   * @param {Event} event
   * @param {Event or Touch} pointer
   * @private
   */
  proto._pointerMove = function (event, pointer) {
    this.pointerMove(event, pointer);
  };

  // public
  proto.pointerMove = function (event, pointer) {
    this.emitEvent('pointerMove', [event, pointer]);
  };

  // ----- end event ----- //


  proto.onmouseup = function (event) {
    this._pointerUp(event, event);
  };

  proto.onpointerup = function (event) {
    if (event.pointerId == this.pointerIdentifier) {
      this._pointerUp(event, event);
    }
  };

  proto.ontouchend = function (event) {
    var touch = this.getTouch(event.changedTouches);
    if (touch) {
      this._pointerUp(event, touch);
    }
  };

  /**
   * pointer up
   * @param {Event} event
   * @param {Event or Touch} pointer
   * @private
   */
  proto._pointerUp = function (event, pointer) {
    this._pointerDone();
    this.pointerUp(event, pointer);
  };

  // public
  proto.pointerUp = function (event, pointer) {
    this.emitEvent('pointerUp', [event, pointer]);
  };

  // ----- pointer done ----- //

  // triggered on pointer up & pointer cancel
  proto._pointerDone = function () {
    this._pointerReset();
    this._unbindPostStartEvents();
    this.pointerDone();
  };

  proto._pointerReset = function () {
    // reset properties
    this.isPointerDown = false;
    delete this.pointerIdentifier;
  };

  proto.pointerDone = noop;

  // ----- pointer cancel ----- //

  proto.onpointercancel = function (event) {
    if (event.pointerId == this.pointerIdentifier) {
      this._pointerCancel(event, event);
    }
  };

  proto.ontouchcancel = function (event) {
    var touch = this.getTouch(event.changedTouches);
    if (touch) {
      this._pointerCancel(event, touch);
    }
  };

  /**
   * pointer cancel
   * @param {Event} event
   * @param {Event or Touch} pointer
   * @private
   */
  proto._pointerCancel = function (event, pointer) {
    this._pointerDone();
    this.pointerCancel(event, pointer);
  };

  // public
  proto.pointerCancel = function (event, pointer) {
    this.emitEvent('pointerCancel', [event, pointer]);
  };

  // -----  ----- //

  // utility function for getting x/y coords from event
  Unipointer.getPointerPoint = function (pointer) {
    return {
      x: pointer.pageX,
      y: pointer.pageY
    };
  };

  // -----  ----- //

  return Unipointer;
});

/***/ }),

/***/ "/opt/app/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--4-0!/opt/app/node_modules/css-loader/index.js!/opt/app/node_modules/webfonts-loader/index.js??ref--4-2!/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/icons/icons__config.js":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/opt/app/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--8-0!/opt/app/node_modules/css-loader/index.js!/opt/app/node_modules/postcss-loader/lib/index.js??ref--8-2!/opt/app/node_modules/sass-loader/lib/loader.js!/opt/app/client/src/site__fus078/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/brand-definition.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "brand-definition-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#brand-definition-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/burger-close.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "burger-close-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#burger-close-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/burger.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "burger-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#burger-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/change-management.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "change-management-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#change-management-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/character-clientservices.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "character-clientservices-usage",
      viewBox: "0 0 640 640",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#character-clientservices-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/character-operations.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "character-operations-usage",
      viewBox: "0 0 640 640",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#character-operations-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/character_creative.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "character_creative-usage",
      viewBox: "0 0 640 640",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#character_creative-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/character_strategy.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "character_strategy-usage",
      viewBox: "0 0 640 640",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#character_strategy-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/character_technology.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "character_technology-usage",
      viewBox: "0 0 640 640",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#character_technology-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/character_you.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "character_you-usage",
      viewBox: "0 0 640 640",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#character_you-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/chevron-down.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "chevron-down-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#chevron-down-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/chevron-left.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "chevron-left-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#chevron-left-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/chevron-right.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "chevron-right-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#chevron-right-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/chevron-up.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "chevron-up-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#chevron-up-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/close.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "close-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#close-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/cms.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "cms-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#cms-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/conversion-rate.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "conversion-rate-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#conversion-rate-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/devop-consulting.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "devop-consulting-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#devop-consulting-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/digital-insights.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "digital-insights-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#digital-insights-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/digital-strategy.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "digital-strategy-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#digital-strategy-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/download.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "download-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#download-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/email-alt.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "email-alt-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#email-alt-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/episerver-logo.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "episerver-logo-usage",
      viewBox: "0 0 640 200",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#episerver-logo-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/error.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "error-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#error-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/external-link.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "external-link-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#external-link-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/facebook-alt.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "facebook-alt-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#facebook-alt-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/facebook.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#facebook-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/fusion-logo.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "fusion-logo-usage",
      viewBox: "0 0 415.255 91.133",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#fusion-logo-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-awardwinning.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon-awardwinning-usage",
      viewBox: "0 0 500 500",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon-awardwinning-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-blog.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon-blog-usage",
      viewBox: "0 0 500 500",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon-blog-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-casestudies.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon-casestudies-usage",
      viewBox: "0 0 500 500",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon-casestudies-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-clientleader.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon-clientleader-usage",
      viewBox: "0 0 500 500",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon-clientleader-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-cog.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon-cog-usage",
      viewBox: "0 0 200 200",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon-cog-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-design.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon-design-usage",
      viewBox: "0 0 500 500",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon-design-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-designer.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon-designer-usage",
      viewBox: "0 0 500 500",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon-designer-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-developer.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon-developer-usage",
      viewBox: "0 0 500 500",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon-developer-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-deviceagnostic.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon-deviceagnostic-usage",
      viewBox: "0 0 500 500",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon-deviceagnostic-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-easyintegration.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon-easyintegration-usage",
      viewBox: "0 0 500 500",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon-easyintegration-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-efficient.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon-efficient-usage",
      viewBox: "0 0 500 500",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon-efficient-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-engaging.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon-engaging-usage",
      viewBox: "0 0 500 500",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon-engaging-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-error.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon-error-usage",
      viewBox: "0 0 250 250",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon-error-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-fast.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon-fast-usage",
      viewBox: "0 0 500 500",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon-fast-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-mobilepayments.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon-mobilepayments-usage",
      viewBox: "0 0 500 500",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon-mobilepayments-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-nativeapps.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon-nativeapps-usage",
      viewBox: "0 0 500 500",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon-nativeapps-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-news.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon-news-usage",
      viewBox: "0 0 500 500",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon-news-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-personalised.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon-personalised-usage",
      viewBox: "0 0 500 500",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon-personalised-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-secure.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon-secure-usage",
      viewBox: "0 0 500 500",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon-secure-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-seo.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon-seo-usage",
      viewBox: "0 0 500 500",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon-seo-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-simple.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon-simple-usage",
      viewBox: "0 0 500 500",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon-simple-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-speed.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon-speed-usage",
      viewBox: "0 0 500 500",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon-speed-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-strategist.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon-strategist-usage",
      viewBox: "0 0 500 500",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon-strategist-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-strategy.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon-strategy-usage",
      viewBox: "0 0 500 500",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon-strategy-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-tech.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon-tech-usage",
      viewBox: "0 0 500 500",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon-tech-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-vr.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon-vr-usage",
      viewBox: "0 0 500 500",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon-vr-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon-you.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon-you-usage",
      viewBox: "0 0 500 500",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon-you-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon_calendar.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon_calendar-usage",
      viewBox: "0 0 512 512",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon_calendar-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon_developers.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon_developers-usage",
      viewBox: "0 0 512 512",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon_developers-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon_mail.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon_mail-usage",
      viewBox: "0 0 512 512",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon_mail-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon_network.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon_network-usage",
      viewBox: "0 0 512 512",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon_network-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon_pencil.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon_pencil-usage",
      viewBox: "0 0 512 512",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon_pencil-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon_people.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon_people-usage",
      viewBox: "0 0 512 512",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon_people-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/icon_web_page.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "icon_web_page-usage",
      viewBox: "0 0 512 512",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#icon_web_page-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/info.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "info-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#info-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/instagram.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "instagram-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#instagram-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/link-next.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "link-next-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#link-next-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/link-prev.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "link-prev-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#link-prev-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/linkedin-alt.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "linkedin-alt-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#linkedin-alt-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/linkedin.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "linkedin-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#linkedin-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/medium.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "medium-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#medium-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/minus.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "minus-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#minus-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/mobile-app.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "mobile-app-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#mobile-app-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/pause.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "pause-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#pause-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/pdf.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "pdf-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#pdf-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/pin.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "pin-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#pin-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/play-round.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "play-round-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#play-round-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/play.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "play-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#play-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/plus.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "plus-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#plus-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/prototyping.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "prototyping-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#prototyping-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/quote.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "quote-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#quote-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/quotemark.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "quotemark-usage",
      viewBox: "0 0 500 500",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#quotemark-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/related-blog.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "related-blog-usage",
      viewBox: "0 0 250 250",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#related-blog-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/related-news.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "related-news-usage",
      viewBox: "0 0 250 250",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#related-news-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/related-work.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "related-work-usage",
      viewBox: "0 0 250 250",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#related-work-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/responsive.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "responsive-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#responsive-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/search.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "search-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#search-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/services-creative.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "services-creative-usage",
      viewBox: "0 0 250 250",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#services-creative-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/services-operations.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "services-operations-usage",
      viewBox: "0 0 500 500",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#services-operations-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/services-strategy.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "services-strategy-usage",
      viewBox: "0 0 250 250",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#services-strategy-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/services-technology.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "services-technology-usage",
      viewBox: "0 0 250 250",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#services-technology-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/share.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "share-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#share-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/sound.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "sound-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#sound-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/spinner.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "spinner-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#spinner-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/success.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "success-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#success-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/tick.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "tick-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#tick-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/title-playtowin.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "title-playtowin-usage",
      viewBox: "0 0 500 500",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#title-playtowin-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/twitter-alt.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "twitter-alt-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#twitter-alt-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/twitter.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "twitter-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#twitter-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/upload-cloud.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "upload-cloud-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#upload-cloud-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/user-centred.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "user-centred-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#user-centred-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/user-experience.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "user-experience-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#user-experience-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/vimeo.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "vimeo-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#vimeo-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/youtube.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "youtube-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#youtube-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "/opt/app/node_modules/svg-sprite-loader/lib/loader.js??ref--6-0!/opt/app/client/src/site__fus078/icons/zoom.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "zoom-usage",
      viewBox: "0 0 100 100",
      url: __webpack_require__.p + "images/sprites--8f6f109c85673cc66c8ba7750ff6285e.svg#zoom-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "multi /opt/app/client/src/site__fus078/index.js /opt/app/client/src/site__fus078/index.scss":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/index.js");
module.exports = __webpack_require__("/opt/app/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--8-0!/opt/app/node_modules/css-loader/index.js!/opt/app/node_modules/postcss-loader/lib/index.js??ref--8-2!/opt/app/node_modules/sass-loader/lib/loader.js!/opt/app/client/src/site__fus078/index.scss");


/***/ })

},["multi /opt/app/client/src/site__fus078/index.js /opt/app/client/src/site__fus078/index.scss"]);


// WEBPACK FOOTER //
// scripts/site__fus078--9846da594a5a7e28b655.js